// Omni Hub IA - Plateforme unifiée multi-agents v2.1
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SupportChatWidget from "../../components/SupportChatWidget";
import { currentShowsMpr, aidesLabel } from "../../utils/profileLabels";
import { isInstallateurProfile, hasDevisCatalogue, hasDossierAmo,
         hasDevisInstallateur, hasIntegrationPennylane } from "../../utils/tenantProfile";
// 🔴 N°728-2 — le registre des capacités du menu vit dans son PROPRE module
// (mesurable par un banc ; ⛔ pas au milieu de cet écran). Cf. son en-tête.
import { aLaCapaciteDuMenu } from "../../utils/capacitesMenu";
import {
  Brain,
  Sparkles,
  FileText,
  Users,
  User,
  LogOut,
  Menu,
  Sun,
  Moon,
  X,
  Settings,
  BarChart3,
  BarChart,
  MessageSquare,
  Loader2,
  ChevronRight,
  ChevronDown,
  Mail,
  Lock,
  Eye,
  EyeOff,
  Phone,
  Megaphone,
  MessageCircle,
  Cog,
  LayoutDashboard,
  LayoutGrid,
  Search,
  Calendar,
  FolderKanban,
  Wrench,
  ClipboardList,
  Building2,
  PieChart,
  UserCog,
  Plug,
  Shield,
  ShieldCheck,
  Crown,
  TrendingUp,
  Target,
  Globe,
  Server,
  Home,
  Bell,
  Euro,
  FileCode,
  Receipt,
  Bot,
  Settings2,
  PenTool,
  Camera,
  File,
  CheckCircle,
  CheckCircle2,
  ClipboardCheck,
  CreditCard,
  Palette,
  UserCheck,
  Hammer,
  Droplets,
  Zap,
  GitBranch,
  Ticket,
  AlertTriangle,
  FileSearch,
  Link2,
  HandCoins
} from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Badge } from "../../components/ui/badge";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from "../../components/ui/dropdown-menu";
import { useAuth } from "../../contexts/AuthContext";
import { PermissionProvider, usePermissions } from "../../contexts/PermissionContext";
import { toast } from "sonner";
import { UserSwitcher } from "../../components/UserSwitcher";
import { ClientSearchSelect } from "../../components/ui/client-search-select";

// Import des composants existants
import CMOAgent from "../marketing/CMOAgent";
import ContentFactory from "../marketing/ContentFactory";
import DashboardAcquisition from "../marketing/DashboardAcquisition";
import MarketingDashboard from "../marketing/MarketingDashboard";
import CMODashboard from "../marketing/CMODashboard";
import PlanningEditorial from "../marketing/PlanningEditorial";
import SEOManager from "../marketing/SEOManager";

// Home Page - Nouvelle version avec widgets par Hub
import HomePage from "./HomePageNew";

// Gouvernance - Espace CTO
import { Governance, peutOuvrirTickets } from "../governance";

// Hub IA - socle des agents (#346). Plein écran, même pattern que Gouvernance.
import HubIA from "../hub-ia/HubIA";

// Communication Hub - Composants
import CallAgents from "../communication/CallAgents";
import MissionsAudrey from "../communication/MissionsAudrey";
import CommunicationDashboard from "../communication/CommunicationDashboard";
import SMSManager from "../communication/SMSManager";
import EmailDashboard from "../communication/EmailDashboard";
import WhatsAppDashboard from "../communication/WhatsAppDashboard";
import AudreyDashboard from "../communication/AudreyDashboard";
import BaileyDashboard from "./communication/BaileyDashboard";
import NativeEmailClient from "./communication/NativeEmailClient";
import EmailWorkerDashboard from "./communication/EmailWorkerDashboard";
import AG04Dashboard from "./communication/AG04Dashboard";
import BureauSimple from "./communication/BureauSimple";
import BureauAmo from "./communication/BureauAmo";
import { synthese as syntheseBureau } from "./communication/bureauAmoApi";
import { CAPACITE_BUREAU_AMO, LIBELLE_BUREAU, accueilParCapacite, accueilEnAttente, bureauSeul, libelleCloche } from "./accueilBureau";
import GamoraGlobalBadge from "../../components/governance/GamoraGlobalBadge";

// Management Hub - Composants
import MailConfig from "../management/MailConfig";
import AgentConfigView from "../management/AgentConfigView";
import EntrepriseConfig from "../management/EntrepriseConfig";
import ManagementDashboard from "../management/ManagementDashboard";
import WebConnectorManager from "../management/WebConnectorManager";
import ConfigMultitenant from "../management/ConfigMultitenant";
import CTODashboard from "../direction/CTODashboard";
import ConfigAgentsPage from "../management/ConfigAgentsPage";
import WebConnectorPage from "../management/WebConnectorPage";
import EmailSettingsPage from "../management/EmailSettingsPage";
import StatisticsPage from "../management/StatisticsPage";
import MonProfil from "../management/MonProfil";
import AssetsCoverage from "../management/AssetsCoverage";
import IdentiteEntreprise from "../management/IdentiteEntreprise";
// #511 — Espace documentaire de la STRUCTURE (bibliothèque + packs de demande).
// Voisin d'« Identité Entreprise » : les deux parlent de TEF, pas d'un dossier.
import HabilitationANAH from "../metier/HabilitationANAH";
// 🔴 #709 — ÉCRAN ORPHELIN REMONTÉ. `BilanAMOControle` existait, appelait de vrais
// endpoints et n'était importé NULLE PART : inatteignable pour JJ. Une capacité
// réelle sans route est une capacité qui n'existe pas — le même défaut que le
// moteur du relevé au #689.
import BilanAMOControle from "../metier/BilanAMOControle";
// Note: Les modules suivants sont maintenant EXCLUSIVEMENT dans Gouvernance:
// - MultiConnectionsManager (Intégrations)
// - RBACManager (Sécurité) → GouvSecurity
// - AuditManager (Audit) → GouvAudit
// - RulesManager (Règles) → GouvRules
// - GrootAgent (Guardian) → GouvGroot

// Operation Hub V1 - Composants
import OperationDashboard from "../operation/OperationDashboard";
import OpTicketsManager from "../operation/TicketsManager";
import UnifiedTicketsPage from "../operation/UnifiedTicketsPage";
import OpMissionsManager from "../operation/MissionsManager";
import OpDossiersManager from "../operation/DossiersManager";
import PlanningGoogleCalendar from "../operation/PlanningGoogleCalendar";
import OpInstallateursManager from "../operation/InstallateursManager";
import InstallateurDocsBatch from "../operation/InstallateurDocsBatch";
import OpVisiteursManager from "../operation/VisiteursManager";
import InterventionsTerrain from "../metier/InterventionsTerrain";
import OpLogsManager from "../operation/LogsManager";
// CC-DEV1-32 — vue d'ensemble installateur (TEF, régie active) : remplace le
// dashboard commercial pour le rôle external (installateur), pas pour les autres.
import InstallateurOverview from "../metier/InstallateurOverview";

// Commercial Hub - Dashboard Commercial (Multi-tenant)
import {
  MetierDashboard,
  DossiersList,
  DossierDetail,
  ProspectsList,
  CreateDossier,
  CataloguePage,
  GererEntreprise,
  ClientDetail,
  AidesModule,
  DevisWizard
} from "../metier";
import CreateDossierTefWizard from "../metier/CreateDossierTefWizard";
import SimulateurMPA from "../metier/SimulateurMPA";   // P-066/E — menu MaPrimeAdapt' dédié (option B), hors module Aides
import ProspectsStagingGrid from "../metier/ProspectsStagingGrid";   // D4 LOT 1 — staging
import RegieLiensAdmin from "../metier/regie/RegieLiensAdmin";        // 🔴 ETI-82 — liens commerciaux (admin)
import DevisAMOForm from "../metier/DevisAMOForm";
import DevisDocument from "../metier/DevisDocument";
import DocumentsTemplatesManager from "../metier/DocumentsTemplatesManager";
import DevisFacturesPage from "../metier/DevisFacturesPage";
import FacturesDomaine from "../../components/core/FacturesDomaine";
import HubGrid from "../metier/HubGrid";
import FileTravailAmo from "../metier/FileTravailAmo";

// Direction IA - Composants de gouvernance
import COODashboard from "../direction/COODashboard";
import CxoMemoryPage from "../direction/CxoMemoryPage";
import CSOAgent from "../commercial/CSOAgent";
import CFODashboard from "../direction/CFODashboard";
import SalesAdminAgent from "../commercial/SalesAdminAgent";
import DashboardPipelineCommercial from "../commercial/DashboardPipelineCommercial";

// Hubs spécialisés - Dashboards
import DashboardConformite from "../hubs/DashboardConformite";
import DashboardFinance from "../hubs/DashboardFinance";
import PennylanePage from "../hubs/PennylanePage";
import PipelineFacturationPage from "../hubs/PipelineFacturationPage";
import TableauBordPage from "../management/TableauBordPage";                      // T-181 — tableau de bord par tenant (lot 1)
import AFaire, { EVENEMENT_OUVRIR_CIBLE } from "../metier/crm/AFaire";           // T-203 — vue « À faire » du suivi des actions
import MessagingPage from "../hubs/MessagingPage";
import AnahSyncPage from "../conformite/AnahSyncPage";
import PrestationsAidesPage from "../conformite/PrestationsAidesPage";
import AidesParClientPage from "../conformite/AidesParClientPage";
import AidesComplementaires from "../conformite/AidesComplementaires";
import SuiviMprPage from "../conformite/SuiviMprPage";
import ComplianceAgentPage from "../conformite/ComplianceAgentPage";

// Missions Marketing - Gouvernance CMO
import MissionsMarketingPage from "../marketing/MissionsMarketingPage";
import DesignStudio from "../marketing/DesignStudio";

// Mobile Bottom Navigation
import MobileBottomNav from "../../components/mobile/MobileBottomNav";
import ErrorBoundaryContenu from "../../components/ErrorBoundaryContenu";
import { useTheme } from "../../contexts/ThemeContext";
import { enteteTenant } from "../../utils/enteteTenant";
import { demarrerSondageVisible, PERIODE_SONDAGE_TICKETS_MS } from "../../lib/sondageVisible";
import { appliquerAccentDuTenant } from "../../utils/accentTenant";

// Agents de Direction IA (transversaux - ne parlent pas aux clients)
const DIRECTION_AGENTS = [
  {
    id: "cmo-ia",
    label: "CMO IA",
    description: "Marketing & Message",
    icon: TrendingUp,
    color: "text-amber-400",
    bgColor: "bg-gradient-to-r from-amber-500/20 to-orange-500/20",
    borderColor: "border-amber-500/30",
    active: true
  },
  {
    id: "cso-ia",
    label: "CSO IA",
    description: "Commercial & Ventes",
    icon: Crown,
    color: "text-green-400",
    bgColor: "bg-gradient-to-r from-green-500/20 to-emerald-500/20",
    borderColor: "border-green-500/30",
    active: true,
    comingSoon: false
  },
  {
    id: "coo-ia",
    label: "COO IA",
    description: "Flux & Opérations",
    icon: Settings,
    color: "text-blue-400",
    bgColor: "bg-gradient-to-r from-blue-500/20 to-cyan-500/20",
    borderColor: "border-blue-500/30",
    active: true,
    comingSoon: false
  },
  {
    id: "cto-ia",
    label: "CTO IA",
    description: "Tech & Stabilité",
    icon: Shield,
    color: "text-red-400",
    bgColor: "bg-gradient-to-r from-red-500/20 to-orange-500/20",
    borderColor: "border-red-500/30",
    active: true,
    comingSoon: false
  },
  {
    id: "cfo-ia",
    label: "CFO IA",
    description: "Finances & Facturation",
    icon: Euro,
    color: "text-yellow-400",
    bgColor: "bg-gradient-to-r from-yellow-500/20 to-amber-500/20",
    borderColor: "border-yellow-500/30",
    active: true,
    comingSoon: false
  }
];

// Note: Les chats CxO sont maintenant intégrés dans chaque cockpit (onglet "Mode Conversationnel")

// =============================================================================
// ARCHITECTURE DES HUBS - Version 2.0
// =============================================================================
//
// FLUX PRINCIPAL :
// Commercial → (signature) → Opération → Conformité → Finance → [Clôture]
//
// Hub Commercial  : Prospects → Clients → Dossiers → Devis → Aides → Signature
// Hub Opération   : Planification → Installation → Photos → Documents → Fin chantier
// Hub Conformité  : Vérif. interne → Vérif. CEE → Vérif. MPR → Validation
// Hub Finance     : Facturation → Pennylane → Encaissement → Solde MPR → Paiement CEE
// Clôture         : Statut final (pas un hub)
//
// =============================================================================


export // 🔴🔴 N°756-3 — « HUB MANAGEMENT » CHEZ UN PEINTRE.
// ⚠️ MESURÉ en PROD par INTÉGRATION : en cliquant « Modifier dans Entreprise »
// (écran Configuration), `mario_bat` atterrit dans un hub nommé « Hub
// Management » — du jargon de pilotage pour quelqu'un qui vient juste corriger
// son SIRET.
// 🔑 ⛔ ON ⛔ NE LE MASQUE PAS : c'est là que vit « Identité Entreprise », la
// CIBLE du bouton. Le masquer ferait du bouton un lien mort — ce que JJ
// interdit (« ⛔ aucun bouton ni lien inactif »). C'est le NOM qui est faux,
// ⛔ pas l'écran : on le DÉRIVE, comme le N°737 l'a fait pour « Visites AMO ».
// ⚠️ tef/omv/climat déclarent l'AMO ou un régime d'aides ⇒ libellé INCHANGÉ.
const LIBELLES_HUB_SANS_AMO = {
  management: "Mon entreprise",
};

function libelleHub(hub) {
  if (!hub) return "";
  if (hasDossierAmo()) return hub.label;
  return LIBELLES_HUB_SANS_AMO[hub.id] || hub.label;
}

const HUBS = [
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB MARKETING - Acquisition et stratégie marketing
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "marketing",
    label: "Hub Marketing",
    icon: Megaphone,
    color: "text-pink-400",
    bgColor: "bg-pink-500/10",
    description: "Acquisition et stratégie marketing",
    feature: "marketing_hub",
    items: [
      // Chaque item est tagué avec son feature flag : la gouvernance (Activation
      // Produit, par tenant) est la source de vérité. Sans tag, l'item resterait
      // toujours visible — ce qui empêchait d'activer SEUL Design Studio pour OMV.
      { id: "dashboard", label: "Dashboard Acquisition", icon: BarChart3, feature: "marketing.dashboard" },
      { id: "missions-marketing", label: "Missions", icon: Target, feature: "marketing.missions" },
      { id: "cmo-ia", label: "CMO IA", icon: Sparkles, feature: "marketing.cmo_ia" },
      { id: "content", label: "Content Factory", icon: FileText, feature: "marketing.content" },
      { id: "design-studio", label: "Design Studio", icon: Palette, feature: "marketing.design_studio" },
      { id: "seo", label: "SEO Manager", icon: Search, feature: "marketing.seo" },
      { id: "planning", label: "Planning Éditorial", icon: Calendar, feature: "marketing.planning" }
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB COMMUNICATION - Canaux de communication multi-canal
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "communication",
    label: "Hub Communication",
    icon: MessageCircle,
    color: "text-cyan-400",
    bgColor: "bg-cyan-500/10",
    description: "Canaux de communication multi-canal",
    feature: "communication_hub",
    // T-462 / T-486 : menu « pour les nuls », REGROUPÉ en deux groupes à sous-titre. « Offre d'aides » a quitté ce hub : elle est dans Hub Conformité › « Aides complémentaires » (onglet Campagne).
    // « Dashboard Activité » (technique) est rangé dans Gouvernance › Outils avancés (super admin) : rien n'est supprimé, l'écran existe toujours (`case "dashboard"`).
    items: [
      { id: "ag04-amo", label: LIBELLE_BUREAU, icon: Mail, feature: CAPACITE_BUREAU_AMO, acces: "bureau_amo", groupe: "Mails" },
      { id: "webmail-ia", label: "Boîte mail", icon: Mail, feature: "communication.emails", groupe: "Mails" },
      // T-404e / T-462 : les réglages de Matthieu (connaissance, règles apprises, classement, import), en dernier du groupe Mails ; même verdict serveur que le Bureau (admin du tenant).
      { id: "reglages-matthieu", label: "Réglages de Matthieu", icon: Settings2, acces: "bureau_amo", groupe: "Mails" },
      { id: "messaging", label: "Messagerie interne", icon: MessageSquare, feature: "communication.messaging", groupe: "Messagerie & téléphone" },
      {
        id: "voice-agents",
        label: "Appels téléphoniques",
        icon: Phone,
        feature: "communication.vocal",
        groupe: "Messagerie & téléphone",
        subItems: [
          { id: "audrey", label: "Suivi des appels (Audrey)", icon: Phone }
        ]
      },
      { id: "sms", label: "SMS", icon: MessageCircle, feature: "communication.sms", groupe: "Messagerie & téléphone" },
      { id: "bailey", label: "WhatsApp", icon: MessageSquare, feature: "communication.whatsapp", groupe: "Messagerie & téléphone" }
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB COMMERCIAL - Acquisition client et préparation des dossiers
  // Flux : Signature → Transfert automatique vers Opération
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "commercial",
    label: "Hub Commercial",
    icon: Crown,
    color: "text-emerald-400",
    bgColor: "bg-emerald-500/10",
    description: "Acquisition client et préparation des dossiers",
    feature: "commercial_hub",
    items: [
      // D4 — Prospects (point d'entrée du flux : prospect → dossier → devis).
      // 🔴 ETI-101-B (décision CTO option A, 08/10) — gouverné par la SEULE
      // capacité `commercial.prospects_staging`, ⛔ plus par `tenants:["omv_france"]`.
      // ⚠️ La liste en dur masquait le menu aux tenants dont la capacité est vraie
      //    (Étincelle ne pouvait pas l'ouvrir, sauf super_admin). Capacité absente
      //    ⇒ menu absent (isFeatureEnabled : UNKNOWN ≠ ENABLED). La capacité de
      //    chaque tenant DOIT être posée explicitement avant le déploiement.
      //    Témoin : utils/menuProspects.eti101.test.js.
      { id: "prospects-staging", label: "Prospects", icon: ClipboardList, feature: "commercial.prospects_staging" },
      // T-203 — « À faire » : actions à échéance (retard, aujourd'hui, semaine). Lecture STRICTE de la capacité ; le serveur refuse aussi sans elle. Visible du compte régie (voir le filtre ci-dessous).
      { id: "a-faire", label: "À faire", icon: ClipboardList, featureStrict: "commercial.crm_actions" },
      // 🔴 ETI-82 — surface ADMIN des LIENS commerciaux (Étincelle). Gate = tenant
      // etincelle + admin/manager (la régie, elle, voit SON lien dans « Prospects »,
      // pas ce menu). ⛔ pas de feature au registre → visible pour ces rôles/tenant.
      // T-332 (M-6) — plus de `tenants:["etincelle"]` : visibilité DÉCLARÉE par la capacité `commercial.liens_commerciaux` (lecture STRICTE : absente = masqué), posée par la migration 098. Masquer n'autorise rien : le serveur garde (admin + `commercial.prospects_staging`).
      { id: "regie-liens", label: "Liens commerciaux", icon: Link2, featureStrict: "commercial.liens_commerciaux", roles: ["admin", "super_admin", "manager"] },
      { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, feature: "commercial.dashboard" },
      // feature ajoutée (2026-06-07) pour permettre le masquage par-tenant (OMV) ;
      // clé absente chez les autres tenants = visible → aucun impact TEF/climatpac.
      { id: "pipeline-conversion", label: "Pipeline Conversion", icon: TrendingUp, feature: "commercial.pipeline_conversion" },
      // CC-DEV1 : menu "Clients" autonome RETIRÉ (validé JJ). Fonctions reloguées :
      // création -> wizard CC-DEV1-31 ; recherche/fiche -> recherche globale topbar
      // (ClientSearchSelect) ; archivage -> fiche client (ClientDetail). La vue
      // ProspectsList (case "clients") reste accessible programmatiquement.
      // 🔴 LOT A — « Clients » RÉTABLI pour les seuls tenants qui le DÉCLARENT (`commercial.clients_menu` = true, lecture EXACTE : ni liste de tenants en dur, ni contournement super-admin).
      //    Les autres tenants restent sur le menu retiré ci-dessus : la clé est absente => masqué.
      { id: "clients", label: "Clients", icon: Users, featureExact: "commercial.clients_menu" },
      // CC-DEV1-22 : menu Dossiers UNIQUE. Les ex-entrées "Tous les dossiers",
      // "Dossiers en traitement", "Dossiers conformité", "Dossiers Finance"
      // (toutes la même HubGrid à réglages près) sont fusionnées en presets
      // dans la grille, gatés par rôle/feature (cf. dossierPresets + HubGrid).
      { id: "dossiers", label: "Dossiers", icon: FolderKanban, feature: "commercial.dossiers" },
      { id: "devis-factures", label: "Devis", icon: Receipt, capability: "devis_catalogue", feature: "commercial.devis" }, // 🔴 `capability` ET ⛔ PLUS `tenants:[…]` — 8e liste en dur de la semaine. Mario vend sur devis et ne voyait pas l'entrée ; TEF garde son parcours AMO car il NE DÉCLARE PAS la capacité. ⚠️ Factures et Aides NE SUIVENT PAS : à qualifier séparément.
      // 🔴 FACTURES — ENTRÉE NATIVE, ⛔ PAS UN HUB FINANCE.
      // Mesuré le 02/09 : l'écran `FacturesDomaine` existait, testé, et n'avait
      // AUCUNE entrée de menu — nulle part. Il ne vivait qu'en onglet interne à
      // « Devis », donc introuvable pour qui cherche « Factures ».
      // ⚠️ Le hub Finance n'était pas la cause : `finance_hub` est explicitement
      // FALSE pour omv_france (prod ET preprod), et il ne porte de toute façon
      // AUCUNE entrée « Factures » — seulement Dashboard CFO, Dossiers à
      // Facturer, Pennylane, Rapports.
      // 🔑 Décision CTO : pour OMV la facture est une FONCTION MÉTIER NATIVE.
      // Le domaine Finance reste au backend ; l'accès est ici, à côté du devis
      // qui la produit. ⛔ Aucun hub créé.
      // 🔑 VISIBILITÉ gouvernée par la clé `commercial.factures_menu` (tenant_features, lecture STRICTE :
      // absente = masqué), plus par une liste de tenants en dur. ⛔ Ce n'est PAS la capacité d'émission
      // `commercial.factures` (elle reste le garde de `feature`). Masquer n'autorise rien : le serveur garde.
      { id: "factures", label: "Factures", icon: Receipt, featureStrict: "commercial.factures_menu", feature: "commercial.factures" },
      // T-198 — plus de liste de tenants en dur : l'entrée est DÉRIVÉE de la capacité de visibilité `commercial.aides_cee_mpr` (lecture STRICTE : seul un
      // True explicite l'affiche), posée par migration pour climatpac et omv_france. TEF a son propre menu « Aides ANAH » (conformité) ; masquer n'ouvre ni n'interdit rien.
      // T-406 : Bureau de Chloé (dossiers non déposés). Éteint par défaut : seul le verdict serveur `acces.bureau_chloe` (module propre + admin + parcours AMO) l'ouvre.
      { id: "bureau-chloe", label: "Bureau de Chloé", icon: Bot, acces: "bureau_chloe" },
      { id: "aides", label: "Aides (MPR/CEE)", icon: Euro, highlight: true, featureStrict: "commercial.aides_cee_mpr", feature: "commercial.aides" },
      // P-066/E — MaPrimeAdapt' en menu DÉDIÉ (option B), indépendant du module
      // Aides (gaté OMV/climatpac). Gate effectif = tenant TEF (MPA = dimension
      // mpa_enabled=True pour TEF) + admins/super-admin. `feature:"mpa_enabled"`
      // conservé (intention JJ) mais absent du registre gouvernance → défaut
      // visible : le vrai gate est la capacité déclarée `dossier_amo` (T-332 : plus de liste de tenants ; pas de fuite OMV/Climat/Mario).
      { id: "mpa", label: "MaPrimeAdapt'", icon: Home, capability: "dossier_amo", roles: ["admin", "super_admin"], feature: "mpa_enabled" },
      // T-367 (Q-2) : file de travail AMO — ce qui manque dans chaque dossier (étape calculée par le serveur, T-366). Même capacité que « MaPrimeAdapt' ».
      { id: "file-travail-amo", label: "File de travail AMO", icon: ClipboardCheck, capability: "dossier_amo", roles: ["admin", "super_admin"] },
      { id: "catalogue", label: "Catalogue", icon: FileText, feature: "commercial.catalogue" },
      { id: "admin-ventes", label: "Chloé — Hub Commercial", icon: Bot, highlight: true, feature: "commercial.admin_ventes" },
      { id: "gerer-entreprise", label: "Configuration", icon: Building2, feature: "commercial.config_entreprise" },
      // P-080/A1 : menu autonome « Documents Templates » RETIRÉ (doublon P-078).
      // Il rendait le composant legacy DocumentsTemplatesManager (metier_documents_templates)
      // = écran VIDE en TEF, alors que la donnée réelle vit dans Configuration →
      // onglet « Documents Templates » (DocumentsEngineTemplates, source unique
      // documents_templates_v2). UN SEUL ACCÈS conservé = via Configuration.
      // (Le case "documents-templates" reste comme route programmatique/héritée.)
      // Routes cachées
      { id: "nouveau-dossier", label: "Nouveau Dossier", icon: FileText, hidden: true },
      { id: "dossier-detail", label: "Fiche Dossier", icon: FileText, hidden: true },
      { id: "devis-wizard", label: "Création Devis", icon: FileText, hidden: true }
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB OPÉRATION - Exécution des travaux et suivi terrain
  // Flux : Fin chantier → Conformité
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "operation",
    label: "Hub Opération",
    icon: Cog,
    color: "text-orange-400",
    bgColor: "bg-orange-500/10",
    description: "Exécution des travaux et suivi terrain",
    feature: "operation_hub",
    items: [
      { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, feature: "operation.dashboard" },
      // CC-DEV1-22 : grille dossiers fusionnée dans le menu Commercial > Dossiers
      // (preset "En traitement"). Entrée retirée ici.
      { id: "planning-calendar", label: "Planning", icon: Calendar, feature: "operation.planification" },
      // 🔴 N°728-1 — l'écran Visiteurs porte le vocabulaire AMO (honoraires,
      // « payé au visiteur »). ⚠️ Il ⛔ n'avait AUCUN gate : ⛔ ni feature, ⛔ ni
      // tenants, ⛔ ni rôle — donc visible dès que le hub Opération est ouvert.
      // 🔴 N°811 — l'entrée suit « AMO OU visites terrain » : un artisan qui fait
      // des visites A des visiteurs (Mario l'est lui-même) et doit saisir leur
      // téléphone. Mesuré (preprod) : visites_terrain = mario_bat + tef ;
      // omv_france et climatpac ⛔ ni l'une ni l'autre ⇒ inchangés. Le
      // vocabulaire AMO de l'écran (« TEF payé », « Montant AMO », « AMO total »,
      // « Visiteurs AMO ») reste gaté par `hasDossierAmo()` DANS VisiteursManager
      // (N°728-1) — c'est lui qu'il fallait gater, ⛔ l'entrée entière.
      { id: "visiteurs", label: "Visiteurs", icon: UserCheck, capability: ["dossier_amo", "visites_terrain"] },
      // ── Interventions terrain (vocabulaire ARTISAN) ────────────────────────
      // 🔑 Capacites `default: False` : ⛔ aucun tenant existant n'en herite.
      //    Elles n'apparaissent que pour un tenant qui les recoit explicitement.
      { id: "visite-travaux", label: "Visite Travaux", icon: Hammer, feature: "operation.visite_travaux" },
      { id: "recherche-fuite", label: "Recherche de fuite", icon: Droplets, feature: "operation.recherche_fuite" },
      { id: "rapports-visite", label: "Rapports de visite", icon: FileText, feature: "operation.rapports_visite" },
      // 🔴 N°728-2 — « Installateurs » = SOUS-TRAITANCE DE LA POSE. Un artisan qui
      // pose lui-même ⛔ n'a personne à sous-traiter. La capacité existe et gate
      // déjà le bloc du dossier (N°690-2) ; le MENU, lui, ⛔ ne l'évaluait pas —
      // le flag `operation.installateurs` suffisait. Les DEUX s'appliquent
      // maintenant : le flag dit « ce hub est ouvert », la capacité dit « ce
      // métier existe chez ce tenant ».
      { id: "installateurs", label: "Installateurs", icon: Wrench,
        capability: "devis_installateur", feature: "operation.installateurs" },
      // 2026-05-20 : item "Devis Inst. (batch IA)" masqué — workflow remplacé par
      // bouton "Déposer mon devis" + "Analyser le devis IA" dans la fiche dossier
      // (onglet Opération). Composant InstallateurDocsBatch conservé pour route
      // directe / besoin futur, mais retiré du menu.
      // { id: "installateur-docs-batch", label: "Devis Inst. (batch IA)", icon: FileSearch, tenants: ["tef"], feature: "operation.installateurs" },
      { id: "tickets-cxo", label: "Tickets", icon: ClipboardList, highlight: true, feature: "operation.tickets" }
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB CONFORMITÉ - Vérifications et validations réglementaires
  // Flux : Validation → Finance
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "conformite",
    label: "Hub Conformité",
    icon: Shield,
    color: "text-blue-400",
    bgColor: "bg-blue-500/10",
    description: "Vérifications et validations réglementaires",
    feature: "conformite_hub",
    items: [
      { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, feature: "conformite.dashboard" },
      // CC-DEV1-22 : grille dossiers fusionnée dans Commercial > Dossiers (preset
      // "Conformité"). Entrée retirée ici.
      // 🔑 Une entrée SANS `feature` n'est JAMAIS filtrée (OmniHub.jsx : le test
      // est `if (item.feature && !isFeatureEnabled(...))`). Mesuré le 2026-09-07 :
      // avec `conformite_hub` ouvert, un rénovateur voyait « Joey (Conformité) »,
      // un agent ANAH hors de son périmètre.
      // ⚠️ Gating sans effet de bord : les 4 tenants qui ont `conformite_hub`
      // portent tous `conformite.verif_interne` — ⛔ personne ne perd l'entrée.
      // T-406 : « Joey » est désormais le Bureau des dossiers déposés ; l'ancien écran de contrôle vit dans Gouvernance › Outils avancés (super admin).
      { id: "bureau-joey", label: "Bureau de Joey", icon: Bot, acces: "bureau_joey" },
      // P-080/A3 → T-332 : gate d'item EXPLICITE par la capacité DÉCLARÉE `dossier_amo` (plus de liste de tenants).
      // Si conformite_hub était activé pour OMV, « Aides ANAH » ne fuiterait pas : OMV ne déclare pas `dossier_amo`
      // (super_admin bypass inchangé).
      { id: "aides-anah", label: "Aides ANAH", icon: Building2, capability: "dossier_amo" },
      { id: "prestations-aides", label: "Prestations d'aides", icon: HandCoins, tenants: ["tef"] },
      // T-421 (AC-1) : client × aide, le verdict du code pour tous les clients (même gate que « Prestations d'aides »).
      // T-486 : UNE entrée « Aides complémentaires » (onglets : Aides par client · Campagne) ; la campagne (ex-« Offre d'aides ») a quitté le Hub Communication.
      { id: "aides-complementaires", label: "Aides complémentaires", icon: Sparkles, tenants: ["tef"] },
      // T-482 : suivi des dossiers MaPrimeRénov' (dépôt, instruction, versement), pour les tenants qui déclarent `mpr` dans leur régime d'aides (Climat).
      { id: "suivi-mpr", label: "Suivi MaPrimeRénov'", icon: HandCoins, capability: "aides_mpr" },
      // ── DÉPLACÉS DEPUIS MANAGEMENT le 2026-08-28 (décision d'architecture) ──
      // ⚠️ Ils vivaient sous `management`, dont le flag `management_hub` vaut
      // **False** pour tef (mesuré preprod ET prod) : ils étaient donc INVISIBLES
      // pour tous sauf super-admin. `conformite_hub` vaut **True** ⇒ le
      // déplacement les rend accessibles, ⛔ il ne les masque pas.
      // ⚠️ Ils restent SANS `feature` (#511, #709) : un flag absent en base
      // rendrait l'entrée invisible. Le gate de capacité `dossier_amo` reste la garde.
      { id: "habilitation-anah", label: "Habilitation ANAH", icon: ShieldCheck, capability: "dossier_amo" },
      { id: "bilan-amo", label: "Bilan AMO", icon: FileText, capability: "dossier_amo" }
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB FINANCE - Facturation, encaissements et aides
  // Flux : Paiement CEE → Clôture (statut final)
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "finance",
    label: "Hub Finance",
    icon: Euro,
    color: "text-purple-400",
    bgColor: "bg-purple-500/10",
    description: "Facturation, encaissements et aides",
    feature: "finance_hub",
    items: [
      { id: "dashboard", label: "Dashboard CFO", icon: LayoutDashboard, feature: "finance.dashboard" },
      // CC-DEV1-22 : grille dossiers fusionnée dans Commercial > Dossiers (preset
      // "Finance", gaté rôle autorisé). Entrée retirée ici.
      // 🔴 ETI-113-B — `integration: "pennylane"` : entrée visible SEULEMENT si le tenant a une
      // intégration Pennylane ACTIVE (source unique `hasIntegrationPennylane`, super-admin inclus).
      // T-180b — entrée de menu EN DOUBLON retirée (hidden) : la liste « À facturer » est la présélection de l'onglet Finance de la grille Dossiers ;
      // la page et ses actions Pennylane (créer / annuler / réconcilier / retirer / chercher / lier) restent routables, ouvertes depuis cet onglet.
      { id: "pipeline-facturation", label: "Dossiers à Facturer", icon: GitBranch, feature: "finance.facturation", integration: "pennylane", hidden: true },
      { id: "pennylane", label: "Pennylane", icon: CreditCard, highlight: true, feature: "finance.pennylane", integration: "pennylane" },
      { id: "rapports-financiers", label: "Rapports", icon: BarChart, feature: "finance.rapports" }
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB MANAGEMENT - Salle de pilotage stratégique
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "management",
    label: "Hub Management",
    icon: Settings,
    color: "text-slate-400",
    bgColor: "bg-zinc-800/300/10",
    description: "Pilotage stratégique et vision globale",
    feature: "management_hub",
    items: [
      { id: "dashboard", label: "Dashboard CEO", icon: PieChart, feature: "management.dashboard" },
      // T-181 — capacité `management.tableau_bord` : lecture STRICTE (absente ou non vraie ⇒ entrée masquée) ; la route serveur refuse aussi.
      { id: "tableau-bord", label: "Tableau de bord", icon: LayoutDashboard, featureStrict: "management.tableau_bord", feature: "management.dashboard" },
      { id: "identite-entreprise", label: "Identité Entreprise", icon: Building2, feature: "management.identite" },
      // ⚠️ 2026-08-28 — `habilitation-anah` (#511) et `bilan-amo` (#709) sont
      // partis vers le **Hub Conformité**. ⛔ Ne pas les redéclarer ici : ils
      // seraient présents deux fois, et `management_hub` valant False les
      // masquerait à nouveau.
      //
      // 🔴 `config-agents` — PLACEMENT TRANSITOIRE, ⚠️ ICI ET NON DANS `hub-ia`.
      //
      // ⚠️ CIBLE : le hub « GOUVERNANCE IA », qui résulte de la FUSION
      // `gouvernance` + `hub-ia` — ⛔ hors périmètre du 28/08. La séparation
      // Bloc IA / gouvernance des agents / fonctions CxO reste à trancher.
      //
      // 🔴 JJ a validé le 28/08 un placement transitoire DANS `hub-ia`.
      // ⛔ IL EST INAPPLICABLE, et c'est mesuré, ⛔ pas supposé :
      //   · `toggleHub("hub-ia")` **retourne ligne ~1069**, AVANT le
      //     `setExpandedHubs` de la ligne ~1074 ⇒ `hub-ia` n'entre JAMAIS dans
      //     `expandedHubs` ;
      //   · le rendu des items est conditionné à `expandedHubs.includes(hub.id)`
      //     (ligne ~2799) ⇒ **les items de `hub-ia` ne sont JAMAIS rendus** ;
      //   · et il n'existe **aucune route URL par module** (le module actif vit
      //     dans l'état React) ⇒ ⛔ aucun chemin de secours.
      // ⇒ L'y placer supprimerait l'accès à la capacité, ce qu'interdit la
      //    consigne elle-même (« aucune capacité rendue inaccessible »).
      //
      // ⚠️ Ce qui débloquerait le déplacement, au choix de JJ : créer le hub
      // fusionné, OU retirer le retour anticipé pour que `hub-ia` se déplie.
      // ⛔ Les deux sont des changements de comportement, hors périmètre du jour.
      { id: "config-agents", label: "Orchestration Agents IA", icon: Bot, feature: "management.agents" },
      { id: "statistics", label: "Statistiques Globales", icon: BarChart, feature: "management.statistics" },
      // P-066/F — 3 écrans Management orphelins restaurés (super-admin only ;
      // les cases du switch existent déjà, backends vivants). Flags management.*
      // défaut False → invisibles sauf super-admin (qui bypasse feature ET rôle).
      // Réf PLAN-RESTAURATION-2026-07-09. NON restaurés (volontaire) :
      // web-connector (front mock), email-settings (doublon), multitenant (endpoint à confirmer).
      { id: "cto", label: "CTO Dashboard", icon: Target, feature: "management.cto", roles: ["super_admin"] },
      { id: "cxo-memory", label: "CxO Memory", icon: Brain, feature: "management.cxo_memory", roles: ["super_admin"] },
      { id: "assets-coverage", label: "Assets Coverage", icon: Server, feature: "management.assets_coverage", roles: ["super_admin"] },
      // T-404e : « Réglages de Matthieu » a quitté ce hub (gardé par `management_hub`, que l'admin d'un tenant n'a pas) : il vit dans Communication, à côté du Bureau.
      // T-404c : « File historique » et « Trace de l'agent » (ex-« Supervision email ») ont quitté ce menu : Gouvernance › Outils avancés (super admin).
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB GOUVERNANCE - Espace CTO / Super Admin
  // Ouvre l'espace Gouvernance complet (plein écran)
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "gouvernance",
    label: "Hub Gouvernance",
    icon: Shield,
    color: "text-red-400",
    bgColor: "bg-red-500/10",
    description: "Espace CTO - Règles, Audit, Sécurité",
    isSpecial: true, // Indique que ce hub ouvre un espace spécial
    items: [
      { id: "open-governance", label: "Ouvrir Gouvernance", icon: Shield }
    ]
  },
  // ═══════════════════════════════════════════════════════════════════════════
  // HUB IA — socle des agents (#346 · RFC-009)
  // Agents, capacités, règles, verdicts. Plein écran, comme Gouvernance.
  // ═══════════════════════════════════════════════════════════════════════════
  {
    id: "hub-ia",
    label: "Hub IA",
    icon: Zap,
    color: "text-cyan-400",
    bgColor: "bg-cyan-500/10",
    description: "Agents IA - Capacités, règles, verdicts",
    isSpecial: true,
    items: [
      // 🔴 ⛔ NE RIEN AJOUTER ICI. Mesuré le 2026-08-28 : un clic sur ce hub
      // ouvre l'espace plein écran (`setShowHubIA(true)`, l. ~1056) et met
      // `activeHub = null` + `activeItem = null`. ⇒ **Tout item déclaré dans
      // `items` est INATTEIGNABLE** : la liste n'est jamais dépliée.
      // ⚠️ Même comportement pour le hub `gouvernance` (`setShowGovernance`).
      // ⚠️ Le drapeau `isSpecial` de ces deux hubs est MORT : 2 déclarations,
      // 0 lecture dans tout le frontend. C'est le `hubId` qui décide.
      { id: "open-hub-ia", label: "Ouvrir le Hub IA", icon: Zap }
    ]
  }
];

// NOTE: L'ancienne structure des hubs (Communication, Commercial, Operation, Management)
// a été conservée en commentaire pour référence historique.
// La nouvelle architecture à 4 hubs principaux (Commercial, Opération, Conformité, Finance)
// est maintenant active ci-dessus.
// 
// ANCIENNE STRUCTURE (ARCHIVÉE) - Ne pas supprimer sans validation utilisateur
// ═══════════════════════════════════════════════════════════════════════════
// - Communication Hub (maintenant dans les hubs transverses)
// - Commercial Hub (fusionné dans Hub Commercial)
// - Operation Hub (fusionné dans Hub Opération + tickets)
// - Management Hub (maintenant dans les hubs transverses)
// ═══════════════════════════════════════════════════════════════════════════

// =============================================================================
// OmniHubInner - Le composant principal (avec accès aux permissions)
// =============================================================================
function OmniHubInner({ permissionTenant, setPermissionTenant, onBureauSeul }) {
  const { user, loading, isAuthenticated, mustChangePassword, loginWithEmail, changePassword, logout } = useAuth();
  const { isHubEnabled: isHubEnabledInner, isSuperAdmin, isFeatureEnabled, isFeatureExact, peutOuvrirBureau, peutOuvrirAcces, loading: permissionsEnChargement } = usePermissions();
  
  // Utilisateur admin = voit tout, user (installateur externe) = vue restreinte
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin' || user?.is_super_admin || isSuperAdmin();
  
  const [activeHub, setActiveHub] = useState(null); // null = HomePage par défaut
  const [activeItem, setActiveItem] = useState(null);
  const [cleBureau, setCleBureau] = useState(0);   // W-1 : un clic sur la cloche rouvre le Bureau sur « Prêt à envoyer »
  const accueilChoisi = useRef(false);
  const [ouvrirProspectId, setOuvrirProspectId] = useState(null);   // T-203 — prospect à ouvrir depuis « À faire »
  // 🔴 P-MARIO-01 — ouvrir un AUTRE dossier DEPUIS une fiche dossier (section « Sites /
  // Adresses d'intervention ») : `activeItem` reste "dossier-detail", React ⛔ ne re-rend
  // pas, la fiche restait sur l'ancien dossier. Ce compteur force le nouveau rendu.
  const [, setDossierNav] = useState(0);
  const [activeDirectionAgent, setActiveDirectionAgent] = useState(null);
  // État pour les pages transversales du header (hors hubs)
  const [activeGlobalPage, setActiveGlobalPage] = useState(null); // "users" | "profil" | "identite" | null
  const [grilleCible, setGrilleCible] = useState(null);   // T-181 — { hub, step } posé par un clic de tuile ; remis à null dès qu'on quitte la grille
  useEffect(() => { if (activeItem !== "dossiers") setGrilleCible(null); }, [activeItem]);   // T-181 — une cible de tuile ne survit pas à la navigation
  const [showHomePage, setShowHomePage] = useState(true); // Afficher HomePage par défaut
  const [showGovernance, setShowGovernance] = useState(false); // Espace Gouvernance CTO
  const [showHubIA, setShowHubIA] = useState(false); // Espace Hub IA (#346)
  const [expandedHubs, setExpandedHubs] = useState([]);
  const [directionOuverte, setDirectionOuverte] = useState(false);   // T-467 : le bloc « Direction IA » est FERMÉ à l'ouverture comme les autres sections ; il s'ouvre pour la page en cours
  const [expandedSubMenus, setExpandedSubMenus] = useState([]); // T-461 : tout est FERMÉ à l'ouverture ; seule la section de la page en cours s'ouvre (effet ci-dessous), le choix de l'utilisateur est gardé
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // CC-42 v2 : sync sidebar state avec le breakpoint au resize.
  // Tailwind `lg` = 1024px. Sans ce listener, l'utilisateur qui passe
  // de mobile (mobileMenuOpen=true overlay) à desktop garde l'overlay
  // par-dessus le contenu, ou inversement passe en desktop replié
  // (`w-20`) puis rebascule mobile avec une sidebar inutilisable.
  useEffect(() => {
    if (typeof window === "undefined") return;
    const onResize = () => {
      const isLg = window.innerWidth >= 1024;
      if (isLg) {
        // Quitte le mode mobile : ferme l'overlay s'il était ouvert.
        setMobileMenuOpen(false);
      } else {
        // Entre en mobile : la sidebar doit être "ouverte" (w-64) pour
        // que l'overlay l'affiche en plein, sinon on a juste les icônes.
        setSidebarOpen(true);
      }
    };
    window.addEventListener("resize", onResize);
    onResize(); // sync initial
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const { theme, toggleTheme, setTheme } = useTheme();
  const [processingAuth, setProcessingAuth] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  // COMPTE RÉGIE (role="regie") — vue cloisonnée (le verrou réel est BACKEND :
  // allowlist middleware + filtre created_by sur /prospects). Côté UX : thème
  // CLAIR forcé (provisoire, pas de sélecteur — chantier design séparé) + on ouvre
  // directement le menu Prospects (ni HomePage ni autre hub visible).
  useEffect(() => {
    if (isAuthenticated && user?.role === "regie") {
      setTheme("light");
      setShowHomePage(false);
      setActiveHub("commercial");
      setActiveItem("prospects-staging");
      setExpandedHubs((prev) => (prev.includes("commercial") ? prev : [...prev, "commercial"]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.role]);

  // État des notifications CxO
  const [cxoNotifications, setCxoNotifications] = useState({
    cmo: { count: 0, lastMessage: null, needsAttention: false },
    coo: { count: 0, lastMessage: null, needsAttention: false },
    cto: { count: 0, lastMessage: null, needsAttention: false }
  });
  const [emailNotifications, setEmailNotifications] = useState({ count: 0, alerts: [] });
  const [whatsappNotifications, setWhatsappNotifications] = useState({ count: 0, alerts: [] });
  const [ticketNotifications, setTicketNotifications] = useState({ mine: [], urgent: [] });
  // T-431b : « Tickets » n'existe dans la Gouvernance que pour un super admin, ou un admin dont le tenant ouvre `gouvernance.tickets`.
  // Installateur / compte externe : ni lecture des tickets pour la cloche, ni lien vers la Gouvernance.
  const ticketsOuvrables = peutOuvrirTickets({
    estSuperAdmin: Boolean(user?.is_super_admin) || isSuperAdmin(),
    estAdmin: user?.role === "admin",
    drapeauActif: isFeatureEnabled,
  });
  const [initialGovernanceWidget, setInitialGovernanceWidget] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  
  // Impersonation state
  const isImpersonating = !!localStorage.getItem("original_admin_token");
  
  // Compteur de tickets CxO ouverts (pour badge discret)
  const [openTicketsCount, setOpenTicketsCount] = useState(0);

  // Gestion multi-entreprises (header global)
  const [entreprises, setEntreprises] = useState([]);
  const [currentEntreprise, setCurrentEntreprise] = useState(permissionTenant || null);

  // Charger les tenants de l'utilisateur (nouveau système multi-tenant)
  useEffect(() => {
    if (!isAuthenticated || !user?.email) return;
    
    const loadUserTenants = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL;

        // Auth via Bearer (localStorage) ET cookie. En cross-origin (preprod) le
        // cookie session_token n'est pas transmis → le middleware ne résout pas
        // l'utilisateur → 401 → liste tenants vide → currentEntreprise null →
        // header "Entreprise" + dashboard KO. Le Bearer (même token) débloque
        // (cf. handleSwitchTenant qui l'envoie déjà).
        const _tok = localStorage.getItem('session_token');
        const res = await fetch(`${API}/api/platform/user/tenants?user_email=${encodeURIComponent(user.email)}`, {
          credentials: 'include',
          headers: {
            ...enteteTenant(currentEntreprise?.slug),
            ...(_tok ? { Authorization: `Bearer ${_tok}` } : {}),
          }
        });
        if (res.ok) {
          const data = await res.json();
          const list = data.tenants || [];
          setEntreprises(list);

          // PERSISTANCE business_model / segments / regime_aides — TOUJOURS, même
          // si currentEntreprise est déjà posé (permissionTenant) : sinon le bloc
          // de sélection ci-dessous (gardé par !currentEntreprise) était SAUTÉ et
          // current_business_model restait "" → isInstallateurProfile()=FALSE pour
          // OMV → header générique + dashboard + bouton Émettre vers l'ancien
          // endpoint (devis reste Brouillon). On résout le tenant effectif
          // (currentEntreprise > current_tenant_slug backend > localStorage >
          // is_default > 1er) et on persiste son profil.
          const _effSlug = currentEntreprise?.slug || data.current_tenant_slug
            || localStorage.getItem('current_tenant_slug');
          const _eff = (_effSlug && list.find(t => t.slug === _effSlug))
            || list.find(t => t.is_default) || list[0];
          if (_eff) {
            localStorage.setItem('current_tenant_slug', _eff.slug);
            localStorage.setItem('current_business_model', _eff.business_model || '');
            appliquerAccentDuTenant(_eff);
            localStorage.setItem('current_segments', JSON.stringify(_eff.segments || []));
            localStorage.setItem('current_regime_aides', JSON.stringify(_eff.regime_aides || []));
              // 🔴 LE PARCOURS DE CRÉATION, tel que le SERVEUR le déclare.
              // ⛔ Aucun repli : si le tenant n'en a pas, on RETIRE la clé —
              // une valeur périmée d'un autre tenant serait pire qu'absente.
              if (_eff.dossier_creation_profile) {
                localStorage.setItem('current_dossier_creation_profile', _eff.dossier_creation_profile);
              } else {
                localStorage.removeItem('current_dossier_creation_profile');
              }
              if (_eff.dossier_activite) {
                localStorage.setItem('current_dossier_activite', _eff.dossier_activite);
              } else {
                localStorage.removeItem('current_dossier_activite');
              }
              // 🔴 CAPABILITY AMO — DÉCLARATION POSITIVE servie par le serveur.
              // ⛔ Remplace la règle EN CREUX `!isOmv`, qui donnait l'onglet
              // « Missions AMO » à tout tenant n'étant pas OMV — donc à Mario.
              // ⛔ Aucun repli : absente ⇒ la clé est RETIRÉE, jamais héritée.
              if (_eff.amo_missions) {
                localStorage.setItem('current_amo_missions', '1');
              } else {
                localStorage.removeItem('current_amo_missions');
              }
              // 🔴 CAPABILITÉ VISITE TERRAIN — même principe : DÉCLARÉE, jamais devinée.
              if (_eff.visites_terrain) {
                localStorage.setItem('current_visites_terrain', '1');
              } else {
                localStorage.removeItem('current_visites_terrain');
              }
              // 🔴 CAPACITÉ DEVIS — DÉCLARÉE, jamais dérivée du business_model.
              if (_eff.devis_catalogue) {
                localStorage.setItem('current_devis_catalogue', '1');
              } else {
                localStorage.removeItem('current_devis_catalogue');
              }
              // 🔴 N°690-2 — SOUS-TRAITANCE : le tenant fait-il POSER ?
              // ⛔ Non déclarée ⇒ clé RETIRÉE, jamais héritée (défaut sûr).
              if (_eff.devis_installateur_requis) {
                localStorage.setItem('current_devis_installateur', '1');
              } else {
                localStorage.removeItem('current_devis_installateur');
              }
              // 🔴 CLI-17 — défaut « installateur interne », mis en cache aux
              //    TROIS points où l'est la capacité voisine. ⚠️ En oublier un
              //    laisserait un chemin où la capacité ⛔ n'arrive JAMAIS.
              if (_eff.devis_installateur_interne_par_defaut) {
                localStorage.setItem('current_devis_installateur_interne_par_defaut', '1');
              } else {
                localStorage.removeItem('current_devis_installateur_interne_par_defaut');
              }
              // 🔴 L2 (N°876) — MODÈLE SITE ADOPTÉ (client → site → dossier) ?
              // ⛔ Non déclaré ⇒ clé RETIRÉE : TEF/OMV/Climat ⛔ ne changent pas.
              if (_eff.dossier_site_requis) {
                localStorage.setItem('current_dossier_site_requis', '1');
              } else {
                localStorage.removeItem('current_dossier_site_requis');
              }
              // Chantier : profil de relevé DÉCLARÉ par le tenant (code) ; absent ⇒ retiré.
              if (_eff.profil_chantier) {
                localStorage.setItem('current_profil_chantier', _eff.profil_chantier);
              } else {
                localStorage.removeItem('current_profil_chantier');
              }
              // Pennylane : capacité DÉCLARÉE du tenant (feature flag integration.pennylane)
              if (_eff.integration_pennylane) {
                localStorage.setItem('current_integration_pennylane', '1');
              } else {
                localStorage.removeItem('current_integration_pennylane');
              }
              // 🔴 CAPACITÉ AIDES/AMO — compose la fiche dossier. DÉCLARÉE.
              if (_eff.dossier_amo) {
                localStorage.setItem('current_dossier_amo', '1');
              } else {
                localStorage.removeItem('current_dossier_amo');
              }
          }

          // Sélectionner le tenant :
          // 1. PRIORITÉ: current_tenant_slug du backend (users.current_tenant)
          // 2. localStorage (pour le cache local)
          // 3. is_default
          // 4. Premier de la liste
          if (list.length > 0 && !currentEntreprise) {
            let selectedTenant = null;
            
            // PRIORITÉ 1: Utiliser current_tenant_slug du backend
            const backendCurrentSlug = data.current_tenant_slug;
            if (backendCurrentSlug) {
              selectedTenant = list.find(t => t.slug === backendCurrentSlug);
            }
            
            // PRIORITÉ 2: localStorage (fallback)
            if (!selectedTenant) {
              const storedSlug = localStorage.getItem('current_tenant_slug');
              if (storedSlug) {
                selectedTenant = list.find(t => t.slug === storedSlug);
              }
            }
            
            // PRIORITÉ 3: is_default ou premier
            if (!selectedTenant) {
              selectedTenant = list.find(t => t.is_default) || list[0];
            }
            
            // Synchroniser localStorage avec le tenant sélectionné
            if (selectedTenant) {
              localStorage.setItem('current_tenant_slug', selectedTenant.slug);
              localStorage.setItem('current_business_model', selectedTenant.business_model || '');
              appliquerAccentDuTenant(selectedTenant);
              localStorage.setItem('current_segments', JSON.stringify(selectedTenant.segments || []));
              if (selectedTenant.dossier_creation_profile) {
                localStorage.setItem('current_dossier_creation_profile', selectedTenant.dossier_creation_profile);
              } else {
                localStorage.removeItem('current_dossier_creation_profile');
              }
              if (selectedTenant.dossier_activite) {
                localStorage.setItem('current_dossier_activite', selectedTenant.dossier_activite);
              } else {
                localStorage.removeItem('current_dossier_activite');
              }
              // 🔴 CAPABILITY AMO — DÉCLARATION POSITIVE servie par le serveur.
              // ⛔ Remplace la règle EN CREUX `!isOmv`, qui donnait l'onglet
              // « Missions AMO » à tout tenant n'étant pas OMV — donc à Mario.
              // ⛔ Aucun repli : absente ⇒ la clé est RETIRÉE, jamais héritée.
              if (selectedTenant.amo_missions) {
                localStorage.setItem('current_amo_missions', '1');
              } else {
                localStorage.removeItem('current_amo_missions');
              }
              // 🔴 CAPABILITÉ VISITE TERRAIN — même principe : DÉCLARÉE, jamais devinée.
              if (selectedTenant.visites_terrain) {
                localStorage.setItem('current_visites_terrain', '1');
              } else {
                localStorage.removeItem('current_visites_terrain');
              }
              // 🔴 CAPACITÉ DEVIS — DÉCLARÉE, jamais dérivée du business_model.
              if (selectedTenant.devis_catalogue) {
                localStorage.setItem('current_devis_catalogue', '1');
              } else {
                localStorage.removeItem('current_devis_catalogue');
              }
              // 🔴 N°690-2 — SOUS-TRAITANCE : le tenant fait-il POSER ?
              // ⛔ Non déclarée ⇒ clé RETIRÉE, jamais héritée (défaut sûr).
              if (selectedTenant.devis_installateur_requis) {
                localStorage.setItem('current_devis_installateur', '1');
              } else {
                localStorage.removeItem('current_devis_installateur');
              }
              // 🔴 CLI-17 — défaut « installateur interne », mis en cache aux
              //    TROIS points où l'est la capacité voisine. ⚠️ En oublier un
              //    laisserait un chemin où la capacité ⛔ n'arrive JAMAIS.
              if (selectedTenant.devis_installateur_interne_par_defaut) {
                localStorage.setItem('current_devis_installateur_interne_par_defaut', '1');
              } else {
                localStorage.removeItem('current_devis_installateur_interne_par_defaut');
              }
              // 🔴 L2 (N°876) — MODÈLE SITE ADOPTÉ (client → site → dossier) ?
              // ⛔ Non déclaré ⇒ clé RETIRÉE : TEF/OMV/Climat ⛔ ne changent pas.
              if (selectedTenant.dossier_site_requis) {
                localStorage.setItem('current_dossier_site_requis', '1');
              } else {
                localStorage.removeItem('current_dossier_site_requis');
              }
              // Chantier : profil de relevé DÉCLARÉ par le tenant (code) ; absent ⇒ retiré.
              if (selectedTenant.profil_chantier) {
                localStorage.setItem('current_profil_chantier', selectedTenant.profil_chantier);
              } else {
                localStorage.removeItem('current_profil_chantier');
              }
              // Pennylane : capacité DÉCLARÉE du tenant (feature flag integration.pennylane)
              if (selectedTenant.integration_pennylane) {
                localStorage.setItem('current_integration_pennylane', '1');
              } else {
                localStorage.removeItem('current_integration_pennylane');
              }
              // 🔴 CAPACITÉ AIDES/AMO — compose la fiche dossier. DÉCLARÉE.
              if (selectedTenant.dossier_amo) {
                localStorage.setItem('current_dossier_amo', '1');
              } else {
                localStorage.removeItem('current_dossier_amo');
              }
              localStorage.setItem('current_regime_aides', JSON.stringify(selectedTenant.regime_aides || []));
            }
            
            setCurrentEntreprise(selectedTenant);
            // Mettre à jour le tenant pour les permissions
            if (setPermissionTenant) {
              setPermissionTenant(selectedTenant);
            }
          }
        }
      } catch (err) {
        console.error('Erreur chargement tenants:', err);
      }
    };
    
    loadUserTenants();
  }, [isAuthenticated, user?.email]);
  
  // Handler pour changer de tenant
  const handleSwitchTenant = async (tenant) => {
    if (!user?.email) return;

    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      // Auth via Bearer (localStorage) ET cookie. L'app authentifie via Bearer
      // (le cookie n'est pas toujours transmis) → sans ce header, le switch
      // recevait une session vide → 401 silencieux → retour sur le tenant par
      // défaut (fix 2026-05-26 : le switch ne persistait jamais).
      const _tok = localStorage.getItem('session_token');
      const switchRes = await fetch(`${API}/api/platform/user/tenants/${tenant.slug}/switch`, {
        method: 'POST',
        credentials: 'include',
        headers: _tok ? { Authorization: `Bearer ${_tok}` } : {},
      });
      if (!switchRes.ok) {
        console.error('Switch tenant échoué:', switchRes.status);
      }

      localStorage.setItem('current_tenant_slug', tenant.slug);
      localStorage.setItem('current_business_model', tenant.business_model || '');
      appliquerAccentDuTenant(tenant);
      localStorage.setItem('current_segments', JSON.stringify(tenant.segments || []));
      localStorage.setItem('current_regime_aides', JSON.stringify(tenant.regime_aides || []));

      setCurrentEntreprise(tenant);
      if (setPermissionTenant) {
        setPermissionTenant(tenant);
      }

      // Reload pour que le middleware re-lise users.current_tenant
      window.location.reload();
    } catch (err) {
      console.error('Erreur switch tenant:', err);
      localStorage.setItem('current_tenant_slug', tenant.slug);
      localStorage.setItem('current_business_model', tenant.business_model || '');
      appliquerAccentDuTenant(tenant);
      localStorage.setItem('current_segments', JSON.stringify(tenant.segments || []));
      localStorage.setItem('current_regime_aides', JSON.stringify(tenant.regime_aides || []));
      setCurrentEntreprise(tenant);
    }
  };

  // Écouter les événements de navigation custom (depuis les missions, etc.)
  useEffect(() => {
    const handleNavigation = (e) => {
      const { hub, item } = e.detail || {};
      if (hub && item) {
        setShowHomePage(false);
        setActiveHub(hub);
        setActiveItem(item);
        setActiveDirectionAgent(null);
        setActiveGlobalPage(null);
        // Ouvrir le hub dans la sidebar si nécessaire
        if (!expandedHubs.includes(hub)) {
          setExpandedHubs(prev => [...prev, hub]);
        }
      }
    };
    
    // Navigation vers un ticket depuis une mission
    const handleNavigateToTicket = (e) => {
      setShowHomePage(false);
      setActiveHub('operation');
      setActiveItem('tickets-cxo');
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null);
      if (!expandedHubs.includes('operation')) {
        setExpandedHubs(prev => [...prev, 'operation']);
      }
    };
    
    // T-181 — un clic sur une tuile ouvre la GRILLE UNIQUE filtrée (grille : onglet + états) ou la liste des pièces (devis / factures).
    const handleOuvrirTuile = (e) => {
      const o = e?.detail;
      if (!o) return;
      setShowHomePage(false);
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null);
      setActiveHub("commercial");
      if (!expandedHubs.includes("commercial")) setExpandedHubs(prev => [...prev, "commercial"]);
      if (o.type === "pieces") { setActiveItem(o.cible === "devis" ? "devis-factures" : "factures"); return; }
      setGrilleCible({ hub: o.hub || "all", step: o.step || "", n: Date.now() });
      setActiveItem("dossiers");
    };

    // T-203 — « À faire » → la fiche EXISTANTE de la cible (prospect : sa grille ouvre la fiche ; client : fiche client).
    const handleOuvrirCible = (e) => {
      const c = e?.detail;
      if (!c?.id) return;
      setActiveHub("commercial");
      if (c.type === "client") { window.__clientId = c.id; setActiveItem("client-detail"); }
      else { setOuvrirProspectId(c.id); setActiveItem("prospects-staging"); }
    };

    // Navigation vers une mission depuis un ticket
    const handleNavigateToMission = (e) => {
      setShowHomePage(false);
      setActiveHub('marketing');
      setActiveItem('missions-marketing');
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null);
      if (!expandedHubs.includes('marketing')) {
        setExpandedHubs(prev => [...prev, 'marketing']);
      }
    };
    
    // Navigation générique depuis d'autres composants (ex: EmailDashboard -> MailConfig)
    const handleGenericNavigate = (e) => {
      const { page } = e.detail || {};
      if (page === 'mail-config') {
        setShowHomePage(false);
        setActiveHub('management');
        setActiveItem('mail-config');
        setActiveDirectionAgent(null);
        setActiveGlobalPage(null);
        if (!expandedHubs.includes('management')) {
          setExpandedHubs(prev => [...prev, 'management']);
        }
      }
    };
    
    window.addEventListener('omnihub:navigate', handleNavigation);
    window.addEventListener('navigate', handleGenericNavigate);
    window.addEventListener('navigate-to-ticket', handleNavigateToTicket);
    window.addEventListener('navigate-to-mission', handleNavigateToMission);
    window.addEventListener('oh:ouvrir-tuile', handleOuvrirTuile);   // T-181 — clic sur une tuile du tableau de bord
    window.addEventListener(EVENEMENT_OUVRIR_CIBLE, handleOuvrirCible);   // T-203 — clic sur une ligne de « À faire »
    
    return () => {
      window.removeEventListener('omnihub:navigate', handleNavigation);
      window.removeEventListener('navigate', handleGenericNavigate);
      window.removeEventListener('navigate-to-ticket', handleNavigateToTicket);
      window.removeEventListener('navigate-to-mission', handleNavigateToMission);
      window.removeEventListener('oh:ouvrir-tuile', handleOuvrirTuile);
      window.removeEventListener(EVENEMENT_OUVRIR_CIBLE, handleOuvrirCible);
    };
  }, [expandedHubs]);

  // Vérifier les notifications CxO périodiquement
  useEffect(() => {
    if (!isAuthenticated) return;

    const checkCxONotifications = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL;
        const token = localStorage.getItem('session_token');
        const res = await fetch(`${API}/api/cxo-chat/notifications`, {
          credentials: 'include',
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (res.ok) {
          const data = await res.json();
          setCxoNotifications(data.notifications || {
            cmo: { count: 0, needsAttention: false },
            coo: { count: 0, needsAttention: false },
            cto: { count: 0, needsAttention: false }
          });
        }
      } catch (err) {
        // Silencieux en cas d'erreur
      }
    };

    // Vérifier au chargement
    checkCxONotifications();

    // Vérifier toutes les 30 secondes
    const interval = setInterval(checkCxONotifications, 30000);

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  // W-1 : accueil par défaut = le Bureau AMO, pour les utilisateurs dont le TENANT porte la capacité (jamais par nom de tenant) ;
  // les autres gardent leur accueil. Une seule fois par session de page : la navigation ensuite reste libre.
  useEffect(() => {
    if (accueilChoisi.current || !isAuthenticated || loading) return;
    const cible = accueilParCapacite({ peutOuvrirBureau: peutOuvrirBureau(), activeHub, activeItem });
    if (!cible) return;
    accueilChoisi.current = true;
    setShowHomePage(false);          // sans cela l'accueil Dashboard reste affiché sous un menu « Bureau AMO » déjà sélectionné
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
    setActiveHub(cible.hub);
    setActiveItem(cible.item);
    setExpandedHubs((h) => (h.includes(cible.hub) ? h : [...h, cible.hub]));
  }, [isAuthenticated, loading, peutOuvrirBureau, activeHub, activeItem]);

  // T-461 : la section de la page en cours est ouverte (hub) ; on ne referme jamais ce que la personne a ouvert, et on ne rouvre pas ce qu'elle a fermé tant que la page ne change pas.
  useEffect(() => { if (activeDirectionAgent) setDirectionOuverte(true); }, [activeDirectionAgent]);
  useEffect(() => {
    if (activeHub) setExpandedHubs((h) => (h.includes(activeHub) ? h : [...h, activeHub]));
  }, [activeHub, activeItem]);

  // T-404c — sur le Bureau, l'écran ne montre QUE le menu ☰, le compte et le Bureau (voir accueilBureau.js).
  const seul = bureauSeul({ peutOuvrirBureau: peutOuvrirBureau(), peutOuvrirAcces, activeHub, activeItem, showHomePage, activeGlobalPage, activeDirectionAgent });
  useEffect(() => { if (onBureauSeul) onBureauSeul(seul); }, [seul, onBureauSeul]);

  // Vérifier les notifications d'actions email
  useEffect(() => {
    if (!isAuthenticated || !peutOuvrirBureau()) return;   // T-351b : pas d'appel (donc pas de 403 toutes les 60 s) pour un compte qui ne peut pas ouvrir le Bureau
    
    const checkEmailNotifications = async () => {
      try {
        // W-1 : le compteur de la cloche lit la synthèse du Bureau (mails prêts + à trancher), plus l'ancienne file.
        const r = await syntheseBureau();
        const c = r?.compteurs || {};
        setEmailNotifications({ count: (Number(c.a_valider) || 0) + (Number(c.a_trancher) || 0), alerts: [] });
      } catch (err) {
        // Silencieux
      }
    };
    
    checkEmailNotifications();
    const interval = setInterval(checkEmailNotifications, 60000); // Toutes les 60s
    return () => clearInterval(interval);
  }, [isAuthenticated, permissionTenant, peutOuvrirBureau]);

  // Vérifier les notifications WhatsApp Bailey (actions en attente)
  useEffect(() => {
    if (!isAuthenticated) return;
    
    const checkWhatsappNotifications = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL;
        const token = localStorage.getItem('session_token');
        const res = await fetch(`${API}/api/bailey/pending-actions?limit=5`, {
          headers: {
            ...(token && { "Authorization": `Bearer ${token}` }),
            ...enteteTenant(permissionTenant)
          }
        });
        if (res.ok) {
          const data = await res.json();
          setWhatsappNotifications({
            count: data.count || 0,
            alerts: (data.actions || []).slice(0, 3).map(a => ({
              title: a.detected_type || 'Message WhatsApp',
              message: a.message_preview || a.group_name,
              group: a.group_name,
              created_at: a.created_at,
            }))
          });
        }
      } catch (err) {
        // Silencieux
      }
    };
    
    checkWhatsappNotifications();
    const interval = setInterval(checkWhatsappNotifications, 60000);
    return () => clearInterval(interval);
  }, [isAuthenticated, permissionTenant]);

  // Tickets OH dans la cloche : ceux assignés à l'user (status != done)
  // + pour super admin : tous les critical/high non-done (hors déjà "mes tickets")
  useEffect(() => {
    if (!isAuthenticated || !user?.email || !ticketsOuvrables) return;

    const isSuper = !!(user?.is_super_admin);

    const fetchTicketNotifs = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL;
        const params = new URLSearchParams({ limit: "100" });
        const res = await fetch(`${API}/api/oh/tickets?${params.toString()}`);
        if (!res.ok) return;
        const data = await res.json();
        const all = Array.isArray(data.tickets) ? data.tickets : [];
        const open = all.filter(t => t.status !== "done");
        const mine = open.filter(t => (t.assigned_to || "").toLowerCase() === user.email.toLowerCase());
        const mineIds = new Set(mine.map(t => t.id));
        const urgent = isSuper
          ? open.filter(t => (t.priority === "critical" || t.priority === "high") && !mineIds.has(t.id))
          : [];
        setTicketNotifications({ mine, urgent });
      } catch (e) {
        // silencieux
      }
    };

    // D-142 : plus de sondage à la minute (onglet visible uniquement, 5 min).
    return demarrerSondageVisible(fetchTicketNotifs, PERIODE_SONDAGE_TICKETS_MS);
  }, [isAuthenticated, user?.email, user?.is_super_admin, ticketsOuvrables]);

  // Charger le compteur de tickets ouverts (pour badge discret dans sidebar)
  useEffect(() => {
    if (!isAuthenticated) return;

    const fetchOpenTicketsCount = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL;
        const token = localStorage.getItem("session_token");
        const res = await fetch(`${API}/api/unified-tickets/stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          const openCount = (data.by_status?.open || 0) + (data.by_status?.in_progress || 0);
          setOpenTicketsCount(openCount);
        }
      } catch (err) {
        // Silencieux
      }
    };

    // D-142 : plus de sondage à la minute (onglet visible uniquement, 5 min).
    return demarrerSondageVisible(fetchOpenTicketsCount, PERIODE_SONDAGE_TICKETS_MS);
  }, [isAuthenticated]);

  // Callback OAuth Emergent — RETIRÉ le 04/08/2026 (#312, Programme 6).
  //
  // Cet effet lisait `location.hash` et, dès qu'une URL contenait
  // `#session_id=`, POSTait AUTOMATIQUEMENT sur /auth/session — sans clic,
  // sans interaction, sur simple visite d'un lien. Le bouton Google étant
  // `disabled`, il ne fermait rien : le déclencheur n'était pas le bouton.
  //
  // C'était la moitié frontend du chemin ; le handler backend a été neutralisé
  // en même temps (410 + retrait de l'allowlist R2). Corriger un seul des deux
  // n'aurait été qu'un demi-correctif.
  //
  // NE PAS réintroduire de lecture de `location.hash` à des fins d'authentification.

  // T-462 : la page d'accueil du Hub Communication est le Bureau de Matthieu (si le serveur l'autorise), sinon la boîte mail ; les autres hubs gardent leur dashboard.
  const accueilDuHub = (hubId) => (hubId === "communication" ? (peutOuvrirBureau() ? "ag04-amo" : "webmail-ia") : "dashboard");

  const toggleHub = (hubId) => {
    // Cas spécial : Hub Gouvernance ouvre l'espace Gouvernance
    if (hubId === "gouvernance") {
      setShowGovernance(true);
      setShowHomePage(false);
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null);
      setActiveHub(null);
      setActiveItem(null);
      return;
    }

    // Cas spécial : Hub IA ouvre l'espace Hub IA (#346), même pattern
    if (hubId === "hub-ia") {
      setShowHubIA(true);
      setShowGovernance(false);
      setShowHomePage(false);
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null);
      setActiveHub(null);
      setActiveItem(null);
      return;
    }
    
    const isExpanding = !expandedHubs.includes(hubId);
    
    setExpandedHubs(prev => 
      prev.includes(hubId) 
        ? prev.filter(h => h !== hubId)
        : [...prev, hubId]
    );
    
    // Quand on déplie un hub, on sélectionne aussi son dashboard
    if (isExpanding) {
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null); // Sortir des pages transversales
      setShowHomePage(false); // Quitter la HomePage
      setActiveHub(hubId);
      setActiveItem(accueilDuHub(hubId));
    }
  };

  // Navigation vers HomePage
  const navigateToHome = () => {
    setShowHomePage(true);
    setActiveHub(null);
    setActiveItem(null);
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
  };

  // Navigation vers un Hub depuis la HomePage
  const navigateToHub = (hubId) => {
    // Cas spécial : Hub Gouvernance ouvre l'espace Gouvernance
    if (hubId === "gouvernance") {
      setShowGovernance(true);
      setShowHomePage(false);
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null);
      setActiveHub(null);
      setActiveItem(null);
      return;
    }

    // Cas spécial : Hub IA ouvre l'espace Hub IA (#346), même pattern
    if (hubId === "hub-ia") {
      setShowHubIA(true);
      setShowGovernance(false);
      setShowHomePage(false);
      setActiveDirectionAgent(null);
      setActiveGlobalPage(null);
      setActiveHub(null);
      setActiveItem(null);
      return;
    }
    
    setShowHomePage(false);
    setActiveHub(hubId);
    setActiveItem(accueilDuHub(hubId));
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
    if (!expandedHubs.includes(hubId)) {
      setExpandedHubs(prev => [...prev, hubId]);
    }
  };

  // Navigation vers les Tickets CxO depuis la HomePage
  const navigateToTickets = () => {
    setShowHomePage(false);
    setActiveHub("operation");
    setActiveItem("tickets-cxo");
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
    if (!expandedHubs.includes("operation")) {
      setExpandedHubs(prev => [...prev, "operation"]);
    }
  };

  // Navigation vers un module spécifique depuis la HomePage
  const navigateToModule = (hubId, moduleId) => {
    setShowHomePage(false);
    setActiveHub(hubId);
    setActiveItem(moduleId);
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
    if (!expandedHubs.includes(hubId)) {
      setExpandedHubs(prev => [...prev, hubId]);
    }
  };

  // Navigation vers un dossier spécifique depuis la HomePage
  const navigateToDossier = (dossierId) => {
    setShowHomePage(false);
    setActiveHub("commercial");
    setActiveItem("dossier-detail");
    window.__dossierId = dossierId;
    window.__hubContext = "commercial";
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
    if (!expandedHubs.includes("commercial")) {
      setExpandedHubs(prev => [...prev, "commercial"]);
    }
  };

  // T-364 (F-4) : du Bureau AMO au dossier. `echanges` ouvre directement les Commentaires filtrés sur les échanges mail.
  const ouvrirDossierDepuisBureau = (dossierId, options) => {
    if (!dossierId) return;
    window.__dossierId = dossierId;
    window.__hubContext = "commercial";
    window.__dossierVoirEchanges = options?.echanges === true;
    window.__dossierOnglet = options?.onglet || null;      // T-406 : Chloé et Joey ouvrent le dossier sur l'onglet utile (pièces, DAL, avance…)
    setShowHomePage(false);
    setActiveHub("commercial");
    setActiveItem("dossier-detail");
    setDossierNav((n) => n + 1);
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
    if (!expandedHubs.includes("commercial")) setExpandedHubs((prev) => [...prev, "commercial"]);
  };

  const selectItem = (hubId, itemId) => {
    setActiveDirectionAgent(null);
    setActiveGlobalPage(null);
    setShowHomePage(false);
    setActiveHub(hubId);
    setActiveItem(itemId);
    setMobileMenuOpen(false);
    if (!expandedHubs.includes(hubId)) {
      setExpandedHubs(prev => [...prev, hubId]);
    }
  };

  const selectDirectionAgent = (agentId) => {
    setActiveDirectionAgent(agentId);
    setActiveGlobalPage(null);
    setShowHomePage(false);
    setMobileMenuOpen(false);
  };

  // Ecran de chargement
  if (loading || processingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--oh-bg)' }}>
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-blue-500 animate-spin mx-auto mb-4" />
          <p className="text-zinc-400">
            {processingAuth ? "Connexion en cours..." : "Chargement..."}
          </p>
        </div>
      </div>
    );
  }

  // Handler pour login email/password
  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoggingIn(true);
    
    try {
      await loginWithEmail(email, password);
    } catch (error) {
      setLoginError(error.message || "Erreur de connexion");
    } finally {
      setLoggingIn(false);
    }
  };

  // Page de changement de mot de passe obligatoire
  if (isAuthenticated && mustChangePassword) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'var(--oh-bg)' }}>
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-500 mb-4">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--oh-text)' }}>Changement de mot de passe</h1>
            <p className="text-sm" style={{ color: 'var(--oh-text-muted)' }}>Votre mot de passe provisoire doit être changé avant de continuer.</p>
          </div>
          <div className="rounded-2xl p-8" style={{ backgroundColor: 'var(--oh-bg-elevated)', border: '1px solid var(--oh-border)' }}>
            <form onSubmit={async (e) => {
              e.preventDefault();
              const currentPwd = e.target.currentPassword.value;
              const newPwd = e.target.newPassword.value;
              const confirmPwd = e.target.confirmPassword.value;
              if (newPwd.length < 8) { setLoginError("8 caractères minimum"); return; }
              if (newPwd !== confirmPwd) { setLoginError("Les mots de passe ne correspondent pas"); return; }
              if (!currentPwd) { setLoginError("Le mot de passe actuel est requis"); return; }
              if (newPwd === currentPwd) { setLoginError("Le nouveau mot de passe doit etre different de l'actuel"); return; }
              try {
                setLoginError("");
                await changePassword(newPwd, currentPwd);
                toast.success("Mot de passe mis à jour !");
              } catch (err) { setLoginError(err.message); }
            }} className="space-y-4">
              {/* 🔴 LE CHAMP QUI MANQUAIT. L'API EXIGE `current_password`
                  (marketing/routes.py:579, durcissement du 07/09) : sans lui la
                  validation etait REFUSEE et le geste IMPOSSIBLE — donc aucun
                  nouveau compte ne pouvait rien creer.
                  ⛔ On AJOUTE le champ ; ⛔ on ne retire PAS l'exigence. */}
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: 'var(--oh-text-muted)' }}>Mot de passe actuel (provisoire)</label>
                <input name="currentPassword" type="password" required autoComplete="current-password"
                  className="w-full px-4 py-3 rounded-xl text-sm border transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500/30"
                  style={{ backgroundColor: 'var(--oh-bg-surface)', borderColor: 'var(--oh-border)', color: 'var(--oh-text)' }}
                  placeholder="Celui recu a la creation du compte" data-testid="current-password-input" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: 'var(--oh-text-muted)' }}>Nouveau mot de passe</label>
                <input name="newPassword" type="password" required minLength={8}
                  className="w-full px-4 py-3 rounded-xl text-sm border transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500/30"
                  style={{ backgroundColor: 'var(--oh-bg-surface)', borderColor: 'var(--oh-border)', color: 'var(--oh-text)' }}
                  placeholder="8 caractères minimum" data-testid="new-password-input" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: 'var(--oh-text-muted)' }}>Confirmer le mot de passe</label>
                <input name="confirmPassword" type="password" required minLength={8}
                  className="w-full px-4 py-3 rounded-xl text-sm border transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500/30"
                  style={{ backgroundColor: 'var(--oh-bg-surface)', borderColor: 'var(--oh-border)', color: 'var(--oh-text)' }}
                  placeholder="Confirmer" data-testid="confirm-password-input" />
              </div>
              {loginError && <p className="text-red-400 text-sm">{loginError}</p>}
              <button type="submit" className="w-full py-3 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-purple-500 hover:opacity-90 transition-opacity" data-testid="change-password-btn">
                Valider le nouveau mot de passe
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // Page de connexion
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'var(--oh-bg)' }}>
        <div className="w-full max-w-md">
          {/* Logo et titre */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 mb-4">
              <Brain className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl font-bold mb-2" style={{ color: 'var(--oh-text)' }}>Omni Hub IA</h1>
            <p style={{ color: 'var(--oh-text-muted)' }}>Plateforme unifiée multi-agents</p>
          </div>

          {/* Formulaire de connexion */}
          <div className="rounded-2xl p-8" style={{ backgroundColor: 'var(--oh-bg-elevated)', border: '1px solid var(--oh-border)' }}>
            <form onSubmit={handleEmailLogin} className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-zinc-400 mb-2">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500" />
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.com"
                    className="pl-10 bg-zinc-800/50 border-zinc-700 text-white"
                    required
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-zinc-400 mb-2">Mot de passe</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500" />
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    className="pl-10 pr-10 bg-zinc-800/50 border-zinc-700 text-white"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300"
                  >
                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>

              {loginError && (
                <p className="text-red-400 text-sm">{loginError}</p>
              )}

              <Button
                type="submit"
                disabled={loggingIn}
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium py-6"
              >
                {loggingIn ? (
                  <><Loader2 className="w-5 h-5 mr-2 animate-spin" /> Connexion...</>
                ) : (
                  "Se connecter"
                )}
              </Button>
            </form>

            {/* SSO Emergent RETIRÉ le 2026-08-05 (#356) — bouton Google, séparateur
                « ou » et mention de déploiement supprimés avec lui. Le séparateur
                n'existait que pour séparer ce formulaire du bouton ; le garder
                aurait laissé un « ou » suivi de rien. Le bouton était `disabled` :
                le désactiver n'était pas le retirer — il conservait son handler et
                l'URL en dur vers l'hôte SSO du tiers. */}
          </div>

          {/* Features */}
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {HUBS.map(hub => (
              <div key={hub.id} className={`${hub.bgColor} border border-zinc-800 rounded-xl p-4`}>
                <hub.icon className={`w-6 h-6 ${hub.color} mb-2`} />
                <p className="text-sm font-medium text-white">{libelleHub(hub)}</p>
                <p className="text-xs text-zinc-500">{hub.items.length} modules</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Rendu du contenu actif
  const renderContent = () => {
    // T-404c : tant que le serveur n'a pas dit si ce compte ouvre le Bureau, ni tableau de bord ni tuiles : une phrase d'attente.
    if (accueilEnAttente({ chargementPermissions: permissionsEnChargement, activeHub, activeItem, showHomePage })) {
      return <p style={{ color: "var(--oh-text-muted)", fontSize: 16 }} data-testid="accueil-attente">Ouverture de votre espace…</p>;
    }
    // HomePage par défaut
    if (showHomePage) {
      return (
        <HomePage 
          onNavigateToHub={navigateToHub} 
          onNavigateToModule={navigateToModule}
          onNavigateToDossier={navigateToDossier}
          onNavigateToTickets={navigateToTickets} 
        />
      );
    }
    
    // Pages transversales du header (hors hubs)
    // MIGRÉ: "users" → Redirige vers Gouvernance (GouvSecurity)
    if (activeGlobalPage === "users") {
      // Au lieu d'afficher RBACManager ici, on redirige vers Gouvernance
      // Cette section ne devrait plus être atteinte car le bouton ouvre Gouvernance directement
      return null;
    }
    if (activeGlobalPage === "identite") {
      return <ConfigMultitenant />;
    }
    if (activeGlobalPage === "profil") {
      return <MonProfil />;
    }
    
    // Cockpits de Direction IA
    if (activeDirectionAgent === "cmo-ia") {
      return <CMOAgent />;
    }
    if (activeDirectionAgent === "coo-ia") {
      return <COODashboard />;
    }
    if (activeDirectionAgent === "cto-ia") {
      return <CTODashboard />;
    }
    if (activeDirectionAgent === "cso-ia") {
      return <CSOAgent />;
    }
    if (activeDirectionAgent === "cfo-ia") {
      return <CFODashboard nomEntreprise={currentEntreprise?.nom || ""} />;
    }
    
    // Marketing Hub
    if (activeHub === "marketing") {
      switch (activeItem) {
        case "dashboard": return <DashboardAcquisition />;
        case "missions-marketing": return <MissionsMarketingPage />;
        case "cmo-ia": return <CMODashboard />;
        case "content": return <ContentFactory />;
        case "design-studio": return <DesignStudio tenantId={currentEntreprise?.slug} />;
        case "planning": return <PlanningEditorial />;
        case "seo": return <SEOManager />;
        default: return <DashboardAcquisition />;
      }
    }
    
    // Communication Hub
    if (activeHub === "communication") {
      const activeTenantId = currentEntreprise?.slug || "climatpac";
      switch (activeItem) {
        case "dashboard": return <CommunicationDashboard />;
        case "messaging": return (
          <MessagingPage 
            tenantId={activeTenantId}
            currentUser={user}
            onNavigate={(target, params) => {
              if (target === "dossier" && params?.id) {
                setActiveHub("commercial");
                setActiveItem("dossier-detail");
                window.__dossierId = params.id;
              }
            }}
          />
        );
        case "audrey": return <AudreyDashboard />;
        case "voice-agents": return <CallAgents onNavigateToAudrey={() => setActiveItem("audrey")} />;
        case "sms": return <SMSManager />;
        case "webmail-ia": return <NativeEmailClient tenantId={currentEntreprise?.slug || "tef"} />;
        case "ag04-amo": return (
          <BureauSimple
            key={cleBureau}
            onOuvrirWebmail={(cible) => { window.__webmailCible = cible; setActiveItem("webmail-ia"); }}
            onOuvrirDossier={ouvrirDossierDepuisBureau}
          />
        );
        case "reglages-matthieu": return (
          <BureauAmo reglages superAdmin={Boolean(user?.is_super_admin || isSuperAdmin())}
            onOuvrirIntegrations={() => { setInitialGovernanceWidget("integrations"); setShowGovernance(true); setShowHomePage(false); setActiveDirectionAgent(null); setActiveGlobalPage(null); setActiveHub(null); setActiveItem(null); }}
            vueInitiale="connaissance"
            onOuvrirWebmail={(cible) => { window.__webmailCible = cible; setActiveItem("webmail-ia"); }}
            onOuvrirDossier={ouvrirDossierDepuisBureau} />
        );
        case "bailey": return <BaileyDashboard tenantId={currentEntreprise?.slug || "tef"} />;
        default: return <CommunicationDashboard />;
      }
    }
    
    // Commercial Hub - Dashboard Commercial (Multi-tenant)
    if (activeHub === "commercial") {
      const navigateCommercial = (target, params) => {
        if (target === "dossier" && params?.id) {
          setActiveItem("dossier-detail");
          window.__dossierId = params.id;
          window.__hubContext = "commercial";
          setDossierNav((n) => n + 1);
        } else if (target === "client" && params?.id) {
          setActiveItem("client-detail");
          window.__clientId = params.id;
        } else if (target === "dossiers") {
          setActiveItem("dossiers");
        } else if (target === "prospects") {
          setActiveItem("prospects");
        } else if (target === "nouveau-dossier") {
          window.__preselectedClientId = undefined;
          setActiveItem("nouveau-dossier");
        } else if (target === "factures") {
          // 🔑 LE RETOUR DU GESTE « FACTURER » : on AMÈNE l'utilisateur sur la
          // facture qu'il vient de créer. ⛔ Le laisser la chercher dans une
          // liste, c'est lui demander de vérifier notre travail.
          window.__factureId = params?.factureId || null;
          setActiveItem("factures");
        } else if (target === "devis-wizard" && params?.dossierId) {
          // Navigation vers le wizard de création de devis
          window.__dossierId = params.dossierId;
          window.__devisId = params.devisId || "new";
          setActiveItem("devis-wizard");
        } else if (target === "devis-document" && params?.devisId) {
          // Vue document (PDF) d'un devis — ouverture par défaut (pas le wizard).
          window.__dossierId = params.dossierId;
          window.__devisId = params.devisId;
          // Origine pour le retour contextuel (grille devis vs fiche dossier).
          window.__devisDocFrom = params.from || null;
          setActiveItem("devis-document");
        }
      };
      
      const handleCreateDossier = (clientId, activité) => {
        window.__preselectedClientId = clientId;
        window.__preselectedActivite = activité;
        setActiveItem("nouveau-dossier");
      };
      
      const handleDossierCreated = (dossier) => {
        window.__preselectedClientId = undefined;
        window.__dossierId = dossier.id;
        setActiveItem("dossier-detail");
      };
      
      // Utiliser le slug du tenant actif au lieu de "jkc" en dur
      const activeTenantId = currentEntreprise?.slug || "jkc";

      // CC-DEV1-22 — presets de la grille Dossiers unique. Le cloisonnement par
      // rôle/hub est PRÉSERVÉ : on calcule la liste avec EXACTEMENT les mêmes
      // signaux que l'ancien filtrage de menus (cf. HubsNavigation) —
      //  • Operation/Conformité : visibles si hub activé OU rôle external
      //    (external voyait ces hubs ; cf. visibleHubs external allowlist)
      //  • Finance : hub activé ET PAS external/regie (external/regie ne voyaient
      //    jamais le hub Finance → preset masqué)
      //  • Tous : rôles admin/super_admin/external ou super_admin (ex all-dossiers)
      // La régie ne voit même pas le menu Dossiers (HubsNavigation la restreint à
      // Prospects) → ce code n'est jamais atteint pour elle.
      const _isExternal = user?.role === "external";
      const _isSA = !!user?.is_super_admin || isSuperAdmin();
      // A5 : la grille Dossiers ouvre sur « Tous » par défaut pour TOUS les
      // utilisateurs (preset "all" en tête). Sûr : le hub "all" est RBAC-scopé
      // côté serveur (hub_grids.py get_dossier_filter(rbac_ctx)) → chacun ne voit
      // que ses dossiers permis, quel que soit le hub. Les autres presets restent
      // gatés par hub activé / rôle.
      const dossierPresets = [{ key: "all", label: "Tous" }, { key: "commercial", label: "Commercial" }];
      if (_isExternal || isHubEnabledInner("operation")) dossierPresets.push({ key: "operation", label: "Opérations" });
      if (_isExternal || isHubEnabledInner("conformite")) dossierPresets.push({ key: "conformite", label: "Conformité" });
      if (!_isExternal && isHubEnabledInner("finance")) dossierPresets.push({ key: "finance", label: "Finance" });

      switch (activeItem) {
        case "dashboard":
          // CC-DEV1-32 : l'installateur (régie active) voit sa vue d'ensemble
          // (KPIs cliquables + liste filtrable). Les autres profils gardent le
          // dashboard commercial standard.
          // P-080/A5 : la sélection du dashboard dérive du PROFIL MÉTIER
          // (business_model installateur), plus du seul rôle "external". Avant, un
          // admin OMV (rôle admin, pas external) tombait sur MetierDashboard = blocs
          // AMO hardcodés (« Pipeline AMO », « Visites AMO »), non pertinents pour un
          // installateur CEE. Désormais : profil installateur (OMV/Climat) →
          // InstallateurOverview ; AMO (TEF) → MetierDashboard.
          if (_isExternal || isInstallateurProfile()) {
            return <InstallateurOverview
              tenantId={activeTenantId}
              onOpenDossier={(id) => { window.__dossierId = id; window.__hubContext = "commercial"; setActiveItem("dossier-detail"); }}
            />;
          }
          // 🔴🔴 N°705-2 — LE DASHBOARD AMO ÉTAIT LE « TOUT LE RESTE ».
          // ⚠️ MESURÉ : `MetierDashboard` porte « Pipeline AMO », « Visites
          // AMO » et le mandataire ; il était rendu par DÉFAUT à quiconque
          // n'est ⛔ ni externe ⛔ ni installateur — donc à `mario_bat`
          // (business_model `renovation`). C'est LA règle en creux : « tout
          // sauf X » change de sens le jour où un X de plus apparaît, et
          // personne ⛔ ne relit la condition ce jour-là.
          // 🔑 ⇒ Le dashboard AMO se DÉCLARE (`hasDossierAmo`), il ⛔ ne
          // s'hérite PAS. tef le déclare ⇒ ⛔ AUCUN changement pour lui.
          // ⛔ Sans capability, on ⛔ n'invente PAS un écran : on montre ce qui
          // est SIEN — ses dossiers.
          if (hasDossierAmo()) {
            return <MetierDashboard tenantId={activeTenantId} onNavigate={navigateCommercial} />;
          }
          return <HubGrid hubName="all" presets={dossierPresets}
                          onOpenDossier={(id) => { window.__dossierId = id; setActiveItem("dossier-detail"); }} />;
        case "dossiers": {
          // A5 : ouverture sur « Tous » par défaut (au lieu de "commercial"). T-181 : une tuile du tableau de bord peut cibler un onglet + des états.
          const cible = grilleCible;
          return <HubGrid key={cible ? `g${cible.n}` : "g0"} hubName={cible?.hub || "all"} etatsInitiaux={cible?.step || ""} presets={dossierPresets}
                          facturationPennylane={(isFeatureEnabled("finance.facturation") && hasIntegrationPennylane()) ? { ouvrirActions: () => { setActiveHub("finance"); setActiveItem("pipeline-facturation"); } } : undefined}
                          onOpenDossier={(id, hub) => { window.__dossierId = id; setActiveItem("dossier-detail"); }} />;
        }
        case "all-dossiers":
          return <HubGrid hubName="all" presets={dossierPresets} onOpenDossier={(id) => { window.__dossierId = id; setActiveItem("dossier-detail"); }} />;
        case "pipeline-conversion":
          return <DashboardPipelineCommercial tenantId={activeTenantId} />;
        case "clients":
          return <ProspectsList tenantId={activeTenantId} onNavigate={navigateCommercial} onCreateDossier={handleCreateDossier} mode={isFeatureExact("commercial.clients_menu") ? "clients" : "prospects"} />;
        case "prospects-staging":
          return <ProspectsStagingGrid tenantId={activeTenantId} ouvrirProspectId={ouvrirProspectId} onProspectOuvert={() => setOuvrirProspectId(null)} />;
        case "a-faire":
          return <AFaire tenantId={activeTenantId} />;
        case "regie-liens":
          return <RegieLiensAdmin tenantId={activeTenantId} />;
        case "aides":
          return <AidesModule tenantId={activeTenantId} onNavigate={navigateCommercial} />;
        // P-066/E — MaPrimeAdapt' en menu dédié (option B), indépendant du module
        // Aides (gaté OMV). Le simulateur est la même source que celui exposé
        // dans AidesModule, monté ici en autonome pour le contexte TEF.
        case "file-travail-amo":
          return <FileTravailAmo tenantId={activeTenantId}
                   onOpenDossier={(id, onglet, bloc) => { window.__dossierId = id; window.__hubContext = "commercial"; window.__dossierOnglet = onglet; window.__dossierBloc = bloc || null; setActiveItem("dossier-detail"); setDossierNav((n) => n + 1); }} />;
        case "mpa":
          return <SimulateurMPA tenantId={activeTenantId} />;
        case "documents-templates":
          return <DocumentsTemplatesManager tenantId={activeTenantId} />;
        case "catalogue":
          return <CataloguePage tenantId={activeTenantId} />;
        case "admin-ventes":
          return <SalesAdminAgent tenantId={activeTenantId} />;
        case "gerer-entreprise":
          return <GererEntreprise 
            tenantId={activeTenantId} 
            onNavigateToManagement={() => {
              setActiveHub("management");
              setActiveItem("identite-entreprise");
              setShowHomePage(false);
            }}
          />;
        case "nouveau-dossier":
          // CC-DEV1 : l'installateur (external) crée via le wizard TEF DÉRIVÉ
          // (profil installateur = étapes réduites Bénéficiaire/Logement/Documents
          // + IA, MPA réservé à l'AMO). Le dossier est auto-rattaché à son
          // installateur_id côté serveur (durcissement RBAC POST /dossiers).
          if (_isExternal) {
            return <CreateDossierTefWizard
              tenantId={activeTenantId}
              activite="tef"
              profile="installateur"
              onBack={() => setActiveItem("dashboard")}
              onSuccess={handleDossierCreated}
            />;
          }
          return <CreateDossier
            tenantId={activeTenantId}
            preselectedClientId={window.__preselectedClientId}
            preselectedActivite={window.__preselectedActivite}
            onBack={() => setActiveItem("dossiers")}
            onSuccess={handleDossierCreated}
          />;
        case "bureau-chloe":                      // T-406 : le Bureau des dossiers non déposés (même écran que celui de Matthieu, paramétré par agent)
          return <BureauSimple key={cleBureau} agent="chloe" onOuvrirDossier={ouvrirDossierDepuisBureau} />;
        case "dossier-detail":
          return <DossierDetail 
            key={window.__dossierId}
            dossierId={window.__dossierId}
            tenantId={activeTenantId}
            onBack={() => setActiveItem("dossiers")}
            onNavigate={navigateCommercial}
            hubContext={window.__hubContext || "commercial"}
          />;
        case "devis-wizard": {
          const isTEF = activeTenantId === "tef";
          if (isTEF) {
            return <DevisAMOForm
              dossierId={window.__dossierId}
              tenantId={activeTenantId}
              onBack={() => setActiveItem("dossier-detail")}
            />;
          }
          return <DevisWizard
            dossierId={window.__dossierId}
            devisId={window.__devisId}
            tenantId={activeTenantId}
            onBack={() => {
              setActiveItem("dossier-detail");
            }}
          />;
        }
        case "devis-document":
          return <DevisDocument
            dossierId={window.__dossierId}
            devisId={window.__devisId}
            tenantId={activeTenantId}
            onNavigate={navigateCommercial}
            onBack={() => setActiveItem(window.__devisDocFrom || "dossier-detail")}
            onModifier={() => {
              window.__devisId = window.__devisId;
              setActiveItem("devis-wizard");
            }}
            onNouveauDevis={() => {
              // Devis signé verrouillé → on crée un NOUVEAU devis dans le même
              // dossier (plusieurs devis/dossier autorisés). devisId="new" =>
              // le wizard crée un brouillon (POST /api/metier/devis).
              window.__devisId = "new";
              setActiveItem("devis-wizard");
            }}
          />;
        case "devis-factures":
          return <DevisFacturesPage 
            tenantId={activeTenantId}
            onNavigate={navigateCommercial}
          />;
        case "factures":
          // ⚠️ `window.__factureId` est CONSOMMÉ à l'ouverture (`onOuvert`), sinon
          // il resterait posé : cliquer « Factures » dans le menu rouvrirait la
          // dernière facture créée au lieu de la liste. ⛔ Un état qui survit à
          // son usage se transforme en surprise.
          return <FacturesDomaine
            ouvrirId={window.__factureId || null}
            onOuvert={() => { window.__factureId = null; }}
            onOuvrirClient={(id) => navigateCommercial("client", { id })}
          />;
        case "client-detail":
          return <ClientDetail
            clientId={window.__clientId}
            tenantId={activeTenantId}
            onBack={() => setActiveItem("prospects")}
            onNavigate={navigateCommercial}
            onCreateDossier={handleCreateDossier}
            currentUser={user}
          />;
        default: 
          // 🔴 N°705-2 — même règle au repli : le dashboard AMO se DÉCLARE.
          return hasDossierAmo()
            ? <MetierDashboard tenantId={activeTenantId} onNavigate={navigateCommercial} />
            : <HubGrid hubName="all" presets={dossierPresets}
                       onOpenDossier={(id) => { window.__dossierId = id; setActiveItem("dossier-detail"); }} />;
      }
    }
    
    // Operation Hub
    if (activeHub === "operation") {
      switch (activeItem) {
        case "dashboard": return <OperationDashboard tenantId={currentEntreprise?.slug || "tef"} onNavigate={(item, data) => {
          if (item === "dossier" && data?.id) {
            window.__dossierId = data.id;
            window.__hubContext = "operation";
            setActiveHub("commercial");
            setActiveItem("dossier-detail");
          }
        }} />;
        case "planning-calendar": return <PlanningGoogleCalendar tenantId={currentEntreprise?.slug || "climatpac"} />;
        case "dossiers-operation":
          return <HubGrid 
            hubName="operation"
            onOpenDossier={(id, hub) => {
              window.__dossierId = id;
              window.__hubContext = hub || "operation";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }}
          />;
        case "tickets-cxo": return <UnifiedTicketsPage />;
        case "tickets": return <OpTicketsManager />;
        case "visiteurs": return <OpVisiteursManager />;
        case "visite-travaux": return <InterventionsTerrain type="visite_travaux" onOpenDossier={(id) => { window.__dossierId = id; window.__hubContext = "operation"; setActiveHub("commercial"); setActiveItem("dossier-detail"); }} />;
        case "recherche-fuite": return <InterventionsTerrain type="recherche_fuite" onOpenDossier={(id) => { window.__dossierId = id; window.__hubContext = "operation"; setActiveHub("commercial"); setActiveItem("dossier-detail"); }} />;
        case "rapports-visite": return <InterventionsTerrain type="rapports_visite" onOpenDossier={(id) => { window.__dossierId = id; window.__hubContext = "operation"; setActiveHub("commercial"); setActiveItem("dossier-detail"); }} />;
        case "installateurs": return <OpInstallateursManager />;
        case "installateur-docs-batch":
          return <InstallateurDocsBatch onOpenDossier={(id) => {
            if (!id) return;
            window.__dossierId = id;
            window.__hubContext = "operation";
            setActiveHub("commercial");
            setActiveItem("dossier-detail");
          }} />;
        default: return <OperationDashboard tenantId={currentEntreprise?.slug || "tef"} onNavigate={(item, data) => {
          if (item === "dossier" && data?.id) {
            window.__dossierId = data.id;
            window.__hubContext = "operation";
            setActiveHub("commercial");
            setActiveItem("dossier-detail");
          }
        }} />;
      }
    }
    
    // Management Hub
    if (activeHub === "management") {
      const activeTenantSlug = currentEntreprise?.slug || "jkc";
      
      switch (activeItem) {
        case "cto": return <CTODashboard />;
        case "dashboard": return <ManagementDashboard />;
        case "tableau-bord": return <TableauBordPage />;
        case "identite-entreprise": return <IdentiteEntreprise tenantSlug={activeTenantSlug} />;
        // ⚠️ 2026-08-28 — `habilitation-anah` et `bilan-amo` sont partis avec leur
        // entrée de menu dans la branche `conformite`. ⛔ Ne pas les remettre ici :
        // cette branche n'est plus atteinte pour eux, et un case en double
        // masquerait le vrai au premier retour en arrière.
        case "config-agents": return <ConfigAgentsPage />;
        case "multitenant": return <ConfigMultitenant />;
        case "web-connector": return <WebConnectorPage />;
        case "email-settings": return <EmailSettingsPage />;
        // mail-config migré vers Gouvernance > Configuration > Emails
        case "statistics": return <StatisticsPage />;
        case "cxo-memory": return <CxoMemoryPage />;
        case "assets-coverage": return <AssetsCoverage currentEntreprise={currentEntreprise} />;
        default: return <ManagementDashboard />;
      }
    }
    
    // Hub Conformité - Vérifications et validations réglementaires
    if (activeHub === "conformite") {
      const activeTenantId = currentEntreprise?.slug || "jkc";
      
      // Composant placeholder pour les modules en construction
      const ComingSoonModule = ({ title, description }) => (
        <div className="flex items-center justify-center h-96">
          <div className="text-center p-8 bg-blue-500/10 border border-blue-500/30 rounded-2xl max-w-md">
            <Shield className="w-12 h-12 text-blue-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>
            <p className="text-zinc-400">{description}</p>
            <Badge className="mt-4 bg-blue-500/20 text-blue-400">En construction</Badge>
          </div>
        </div>
      );
      
      switch (activeItem) {
        case "dashboard": 
          return <DashboardConformite tenantId={activeTenantId} onNavigate={(item, data) => {
            if (item === "dossier" && data?.id) {
              window.__dossierId = data.id;
              window.__hubContext = "conformite";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }
          }} />;
        case "bureau-joey":                       // T-406 : le Bureau des dossiers déposés (même écran que celui de Matthieu, paramétré par agent)
          return <BureauSimple key={cleBureau} agent="joey" onOuvrirDossier={ouvrirDossierDepuisBureau} />;
        case "agent-conformite":                  // ancien écran « Joey (Conformité) » : gardé pour les liens existants, rangé dans Gouvernance › Outils avancés
          return <ComplianceAgentPage tenantId={currentEntreprise?.slug || "tef"} />;
        case "dossiers-conformite": 
          return <HubGrid 
            hubName="conformite"
            onOpenDossier={(id, hub) => {
              window.__dossierId = id;
              window.__hubContext = hub || "conformite";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }}
          />;
        case "aides-anah":
          return <AnahSyncPage tenantId={currentEntreprise?.slug || "jkc"} />;
        case "aides-complementaires":
        case "offre-aides":
          return <AidesComplementaires
            ongletInitial={activeItem === "offre-aides" ? "campagne" : "clients"}
            peutCampagne={peutOuvrirBureau()}
            tenantId={currentEntreprise?.slug || "jkc"}
            onOpenDossier={(id) => {
              window.__dossierId = id;
              window.__hubContext = "conformite";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }}
          />;
        case "suivi-mpr":
          return <SuiviMprPage
            tenantId={currentEntreprise?.slug || "jkc"}
            onOpenDossier={(id) => {
              window.__dossierId = id;
              window.__hubContext = "conformite";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }}
          />;
        case "aides-par-client":
          return <AidesParClientPage
            tenantId={currentEntreprise?.slug || "jkc"}
            onOpenDossier={(id) => {
              window.__dossierId = id;
              window.__hubContext = "conformite";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }}
          />;
        case "prestations-aides":
          return <PrestationsAidesPage
            tenantId={currentEntreprise?.slug || "jkc"}
            onOpenDossier={(id) => {
              window.__dossierId = id;
              window.__hubContext = "conformite";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }}
          />;
        // ── DÉPLACÉS DEPUIS LA BRANCHE `management` le 2026-08-28 ──────────
        // 🔴 UN MODULE SE DÉCLARE À DEUX ENDROITS, ET LES DEUX PORTENT LE HUB :
        //   1. le MENU        — `HUBS[].items[]`
        //   2. le RENDU       — `if (activeHub === …) { switch (activeItem) }`
        // ⚠️ Le `switch` est bien indexé sur l'item, mais il est ENVELOPPÉ dans
        // un test de hub : c'est l'enveloppe qui décide. Déplacer le menu SEUL
        // laisse le hub d'arrivée tomber sur son `default` — ici
        // `<DashboardConformite>` : l'entrée s'affiche, le mauvais composant
        // se rend, ⛔ sans erreur ni page blanche.
        // ⛔ Un `grep` sur `case "<id>":` ⛔ NE PEUT PAS voir cette enveloppe :
        // il prouve la PRÉSENCE du case, ⛔ jamais son ATTEIGNABILITÉ.
        case "habilitation-anah":
          return <HabilitationANAH />;
        case "bilan-amo":
          return <BilanAMOControle />;
        default:
          return <DashboardConformite tenantId={activeTenantId} onNavigate={(item, data) => {
            if (item === "dossier" && data?.id) {
              window.__dossierId = data.id;
              window.__hubContext = "conformite";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }
          }} />;
      }
    }
    
    // Hub Finance - Facturation, encaissements et aides
    if (activeHub === "finance") {
      const activeTenantId = currentEntreprise?.slug || "jkc";
      
      // Composant placeholder pour les modules en construction
      const ComingSoonModule = ({ title, description }) => (
        <div className="flex items-center justify-center h-96">
          <div className="text-center p-8 bg-purple-500/10 border border-purple-500/30 rounded-2xl max-w-md">
            <Euro className="w-12 h-12 text-purple-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>
            <p className="text-zinc-400">{description}</p>
            <Badge className="mt-4 bg-purple-500/20 text-purple-400">En construction</Badge>
          </div>
        </div>
      );
      
      switch (activeItem) {
        case "dashboard": 
          return <DashboardFinance tenantId={activeTenantId} onNavigate={(item, data) => {
            if (item === "dossier" && data?.id) {
              window.__dossierId = data.id;
              window.__hubContext = "finance";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }
          }} />;
        case "dossiers-finance":
          return <HubGrid 
            hubName="finance"
            onOpenDossier={(id, hub) => {
              window.__dossierId = id;
              window.__hubContext = hub || "finance";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }}
          />;
        case "pennylane": 
          return <PennylanePage 
            tenantId={currentEntreprise?.slug || "climatpac"} 
            onNavigate={(item, data) => {
              if (item === "dossier" && data?.id) {
                window.__dossierId = data.id;
                setActiveHub("commercial");
                setActiveItem("dossier-detail");
              }
            }}
          />;
        case "pipeline-facturation":
          return <PipelineFacturationPage
            tenantId={currentEntreprise?.slug || "tef"}
            onNavigate={(item, data) => {
              if (item === "dossier" && data?.id) {
                window.__dossierId = data.id;
                setActiveHub("commercial");
                setActiveItem("dossier-detail");
              }
            }}
          />;
        case "rapports-financiers": 
          return <ComingSoonModule 
            title="Rapports Financiers" 
            description="Tableaux de bord et exports financiers" 
          />;
        default: 
          return <DashboardFinance tenantId={activeTenantId} onNavigate={(item, data) => {
            if (item === "dossier" && data?.id) {
              window.__dossierId = data.id;
              window.__hubContext = "finance";
              setActiveHub("commercial");
              setActiveItem("dossier-detail");
            }
          }} />;
      }
    }
    
    return <ManagementDashboard />;
  };

  // Breadcrumb dynamique
  const getBreadcrumb = () => {
    // HomePage
    if (showHomePage) {
      return {
        section: null,
        sectionColor: "text-zinc-400",
        item: "Accueil"
      };
    }
    
    // Pages transversales du header (hors hubs)
    if (activeGlobalPage === "users") {
      return {
        section: null, // Pas de hub
        sectionColor: "text-zinc-400",
        item: "Utilisateurs & Rôles"
      };
    }
    if (activeGlobalPage === "identite") {
      return {
        section: null, // Pas de hub
        sectionColor: "text-zinc-400",
        item: "Identité Entreprise"
      };
    }
    if (activeGlobalPage === "profil") {
      return {
        section: null, // Pas de hub
        sectionColor: "text-zinc-400",
        item: "Mon Profil"
      };
    }
    
    if (activeDirectionAgent) {
      const agent = DIRECTION_AGENTS.find(a => a.id === activeDirectionAgent);
      return {
        section: "Direction IA",
        sectionColor: "text-amber-400",
        item: agent?.label || "Agent"
      };
    }
    const hub = HUBS.find(h => h.id === activeHub);
    const item = hub?.items.find(i => i.id === activeItem);
    return {
      // N°764 : le fil d'Ariane lit le MÊME libellé dérivé que le menu (N°756-3).
      section: libelleHub(hub) || "Hub",
      sectionColor: hub?.color || "text-white",
      // #8 : le fil d'ariane suit le label dérivé de l'item Aides (CEE-only → "Aides (CEE)").
      item: (item?.id === 'aides' ? aidesLabel('aides_menu', currentShowsMpr()) : item?.label) || "Dashboard"
    };
  };

  // HUB IA - socle des agents (plein écran) — #346
  if (showHubIA) {
    return (
      <HubIA
        onClose={() => {
          setShowHubIA(false);
          setShowHomePage(true);
        }}
        onOpenDossier={(id) => {
          // Lien d'un point à vérifier vers son dossier (T-431 / PN-18)
          window.__dossierId = id;
          window.__hubContext = "commercial";
          setShowHubIA(false);
          setShowHomePage(false);
          setActiveHub("commercial");
          setActiveItem("dossier-detail");
        }}
      />
    );
  }

  // GOUVERNANCE - Espace CTO (plein écran)
  if (showGovernance) {
    return (
      <Governance
        onClose={() => {
          setShowGovernance(false);
          setShowHomePage(true);
          setInitialGovernanceWidget(null);
        }}
        currentUser={user}
        currentTenant={currentEntreprise}
        tenants={entreprises}
        initialWidget={initialGovernanceWidget}
      />
    );
  }

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: 'var(--oh-bg)' }}>
      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <aside className={`
        ${sidebarOpen ? 'w-64' : 'w-20'} 
        flex flex-col transition-all duration-300
        fixed lg:relative z-50 h-full
        ${mobileMenuOpen ? 'translate-x-0 w-64' : '-translate-x-full lg:translate-x-0'}
      `} style={{ backgroundColor: 'var(--oh-sidebar-bg)', borderRight: '1px solid var(--oh-border)' }}>
        {/* Header */}
        <div className="p-4" style={{ borderBottom: '1px solid var(--oh-border)' }}>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center flex-shrink-0">
              <Brain className="w-5 h-5 text-white" />
            </div>
            {sidebarOpen && (
              <div>
                <h1 className="text-lg font-bold" style={{ color: 'var(--oh-text)' }}>Omni Hub IA</h1>
                <p className="text-xs" style={{ color: 'var(--oh-text-muted)' }}>Plateforme unifiée</p>
              </div>
            )}
          </div>
        </div>

        {/* Direction IA - Bloc unique de pilotage stratégique - visible si feature flag activé.
            Masqué pour external ET regie (la régie ne voit QUE Hub Commercial/Prospects). */}
        {isFeatureEnabled("direction_ia") && user?.role !== "external" && user?.role !== "regie" && (
        <div className="px-3 py-3" style={{ borderBottom: '1px solid var(--oh-border)' }}>
          <button type="button" onClick={() => setDirectionOuverte((o) => !o)} aria-expanded={directionOuverte} data-testid="nav-direction-ia-bascule" aria-label="Direction IA"
            className="w-full flex items-center gap-2 px-1 mb-1 text-xs font-semibold uppercase tracking-wider" style={{ color: 'var(--oh-text-muted)' }}>
            <Crown className="w-3 h-3 text-amber-400" />
            {sidebarOpen && <span className="flex-1 text-left">Direction IA</span>}
            {sidebarOpen && (directionOuverte ? <ChevronDown className="w-3 h-3" /> : <ChevronRight className="w-3 h-3" />)}
          </button>
          {directionOuverte && (<div className="space-y-1">
            {DIRECTION_AGENTS.map(agent => {
              const isAgentActive = activeDirectionAgent === agent.id;
              
              return (
                <button
                  key={agent.id}
                  onClick={() => !agent.comingSoon && selectDirectionAgent(agent.id)}
                  disabled={agent.comingSoon}
                  data-testid={`nav-${agent.id}`}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all ${
                    agent.comingSoon
                      ? 'opacity-50 cursor-not-allowed'
                      : isAgentActive
                        ? `${agent.bgColor} ${agent.borderColor} border shadow-lg`
                        : 'hover:bg-zinc-800/50 border border-transparent'
                  }`}
                >
                  <div className={`w-9 h-9 rounded-lg ${agent.bgColor} flex items-center justify-center flex-shrink-0`}>
                    <agent.icon className={`w-4 h-4 ${agent.color}`} />
                  </div>
                  {sidebarOpen && (
                    <div className="text-left flex-1">
                      <div className="flex items-center gap-2">
                        <span className={`text-sm font-medium ${isAgentActive ? agent.color : 'text-white'}`}>
                          {agent.label}
                        </span>
                        {agent.comingSoon && (
                          <span className="text-[9px] px-1.5 py-0.5 rounded bg-zinc-700 text-zinc-400 font-medium">
                            À VENIR
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-zinc-500">{agent.description}</p>
                    </div>
                  )}
                </button>
              );
            })}
          </div>)}
        </div>
        )}

        {/* Navigation */}
        <nav className="flex-1 p-3 overflow-y-auto">
          {/* Les 4 Hubs - Filtrés selon les permissions */}
          <HubsNavigation 
            hubs={HUBS}
            activeHub={activeHub}
            activeItem={activeItem}
            activeDirectionAgent={activeDirectionAgent}
            expandedHubs={expandedHubs}
            expandedSubMenus={expandedSubMenus}
            sidebarOpen={sidebarOpen}
            openTicketsCount={openTicketsCount}
            currentEntreprise={currentEntreprise}
            currentUser={user}
            toggleHub={toggleHub}
            selectItem={selectItem}
            setExpandedSubMenus={setExpandedSubMenus}
          />
        </nav>

        {/* User & Actions */}
        <div className="p-3 border-t border-zinc-800">
          {/* Toggle Sidebar */}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-zinc-400 hover:text-white hover:bg-zinc-800/50 transition-colors"
          >
            <Menu className="w-5 h-5" />
            {sidebarOpen && <span className="text-sm">Réduire</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto w-full lg:w-auto">
        {/* Header avec Breadcrumb + User Info (style Google) */}
        <div className="px-4 lg:px-6 py-3" style={{ backgroundColor: 'var(--oh-header-bg)', borderBottom: '1px solid var(--oh-border)' }}>
          <div className="flex items-center justify-between">
            {/* Mobile hamburger + Breadcrumb */}
            <div className="flex items-center gap-2 text-sm">
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden p-2 -ml-2 rounded-lg text-zinc-400 hover:text-white hover:bg-zinc-800/50 transition-colors"
                data-testid="mobile-menu-toggle"
                aria-label="Ouvrir le menu"
              >
                <Menu className="w-5 h-5" />
              </button>
              {!seul && (<>
              <button 
                onClick={navigateToHome}
                className="text-zinc-500 hover:text-zinc-300 transition-colors"
              >
                Omni Hub IA
              </button>
              {/* Afficher section seulement si elle existe (pas pour pages transversales) */}
              {getBreadcrumb().section && (
                <>
                  <ChevronRight className="w-4 h-4 text-zinc-600" />
                  <button 
                    onClick={() => {
                      if (activeDirectionAgent) {
                        // Déjà dans Direction IA, ne rien faire
                      } else {
                        // Retourner au dashboard du hub actif
                        setActiveItem("dashboard");
                      }
                    }}
                    className={`${getBreadcrumb().sectionColor} hover:opacity-80 transition-opacity`}
                  >
                    {getBreadcrumb().section}
                  </button>
                </>
              )}
              <ChevronRight className="w-4 h-4 text-zinc-600" />
              <span className="text-white">
                {getBreadcrumb().item}
              </span>
              {activeDirectionAgent && (
                <Badge className="ml-2 bg-amber-500/20 text-amber-400 border-amber-500/30">
                  Agent Stratégique
                </Badge>
              )}
              </>)}
            </div>

            {/* Header Global - Ordre : Entreprise | Notifications | Utilisateurs | Paramètres | Profil */}
            {user && (
              <div className="flex items-center gap-2">
                {/* 0. Recherche globale client (CC-DEV1 — relocation menu Clients).
                       Gatée non-installateur : un external ne voit pas tous les clients.
                       Sur sélection → ouvre la fiche client (commercial/client-detail). */}
                {user?.role !== "external" && (
                  <div className="hidden md:block w-56 lg:w-64" data-testid="global-client-search">
                    <ClientSearchSelect
                      placeholder="Rechercher un client…"
                      onChange={(id) => {
                        if (id) {
                          window.__clientId = id;
                          setActiveHub("commercial");
                          setActiveItem("client-detail");
                        }
                      }}
                    />
                  </div>
                )}
                {/* 1. Sélecteur de Tenant (Entreprise) */}
                {(<DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button 
                      className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-zinc-800/50 rounded-lg border border-white/5 hover:bg-zinc-800 transition-colors"
                      data-testid="header-tenant-selector"
                    >
                      <Building2 className="w-4 h-4 text-emerald-400" />
                      <span className="text-sm text-zinc-300">{currentEntreprise?.nom || 'Entreprise'}</span>
                      {currentEntreprise?.role === 'admin' && (
                        <span className="text-[9px] px-1 py-0.5 rounded bg-emerald-500/20 text-emerald-400 font-medium">
                          Admin
                        </span>
                      )}
                      <ChevronDown className="w-3 h-3 text-zinc-500" />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-72 bg-zinc-900 border-white/10">
                    <div className="px-3 py-2 border-b border-white/5">
                      <p className="text-xs text-zinc-500">Entreprise active</p>
                      <p className="text-sm font-medium text-white">{currentEntreprise?.nom || 'Non définie'}</p>
                      {currentEntreprise?.identite?.siret && (
                        <p className="text-xs text-zinc-500 mt-0.5">SIRET: {currentEntreprise.identite.siret}</p>
                      )}
                    </div>
                    {entreprises.length > 1 && (
                      <>
                        <div className="px-3 py-1.5">
                          <p className="text-xs text-zinc-500">Changer d&apos;entreprise</p>
                        </div>
                        {entreprises.filter(e => e.id !== currentEntreprise?.id).map(ent => (
                          <DropdownMenuItem 
                            key={ent.id}
                            onClick={() => handleSwitchTenant(ent)}
                            className="cursor-pointer hover:bg-zinc-800"
                            data-testid={`switch-tenant-${ent.slug}`}
                          >
                            <Building2 className="w-4 h-4 mr-2 text-zinc-500" />
                            <div className="flex-1">
                              <span className="text-sm">{ent.nom}</span>
                              {ent.role === 'admin' && (
                                <span className="ml-2 text-[9px] px-1 py-0.5 rounded bg-zinc-700 text-zinc-400">
                                  Admin
                                </span>
                              )}
                            </div>
                          </DropdownMenuItem>
                        ))}
                      </>
                    )}
                    {isAdmin && (
                    <div className="border-t border-white/5 mt-1 pt-1">
                      <DropdownMenuItem 
                        onClick={() => { 
                          setActiveDirectionAgent(null);
                          setShowHomePage(false);
                          setActiveHub("management");
                          setActiveItem("identite-entreprise");
                          if (!expandedHubs.includes("management")) {
                            setExpandedHubs(prev => [...prev, "management"]);
                          }
                        }}
                        className="cursor-pointer hover:bg-zinc-800 text-zinc-400"
                        data-testid="header-identite-entreprise"
                      >
                        <Settings className="w-4 h-4 mr-2" />
                        Gérer l&apos;identité
                      </DropdownMenuItem>
                    </div>
                    )}
                  </DropdownMenuContent>
                </DropdownMenu>)}

                {/* 2. Notifications CxO - Admin/SuperAdmin seulement */}
                {isAdmin && (
                <>
                {/* Gamora = Gouvernance → super_admin uniquement (Option 1, AUDIT-GAMORA-GATING) */}
                {(user?.is_super_admin || isSuperAdmin()) && (
                <GamoraGlobalBadge onClick={() => {
                  // Gouvernance est un espace plein écran (pas un hub) : on l'ouvre sur Gamora.
                  setInitialGovernanceWidget("gamora");
                  setShowGovernance(true);
                  setShowHomePage(false);
                  setActiveDirectionAgent(null);
                  setActiveGlobalPage(null);
                  setActiveHub(null);
                  setActiveItem(null);
                }} />
                )}
                <DropdownMenu open={showNotifications} onOpenChange={setShowNotifications}>
                  <DropdownMenuTrigger asChild>
                    <button
                      className="relative p-2 rounded-lg hover:bg-zinc-800/50 transition-colors"
                      data-testid="header-notifications"
                    >
                      <Bell className="w-5 h-5 text-zinc-400" />
                      {(cxoNotifications.cmo?.needsAttention ||
                        cxoNotifications.coo?.needsAttention ||
                        cxoNotifications.cto?.needsAttention ||
                        emailNotifications.count > 0 ||
                        whatsappNotifications.count > 0 ||
                        ticketNotifications.mine.length > 0 ||
                        ticketNotifications.urgent.length > 0) && (
                        <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse" />
                      )}
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-96 bg-zinc-900 border-white/10">
                    <div className="px-3 py-2 border-b border-white/5">
                      <p className="text-sm font-medium text-white flex items-center gap-2">
                        <Brain className="w-4 h-4 text-amber-400" />
                        Direction IA - Actions requises
                      </p>
                      <p className="text-xs text-zinc-500 mt-1">
                        Décisions nécessitant votre intervention
                      </p>
                    </div>
                    
                    {/* Alertes CMO */}
                    {cxoNotifications.cmo?.alerts?.map((alert, i) => (
                      <DropdownMenuItem 
                        key={`cmo-${i}`}
                        onClick={() => {
                          setActiveHub("operation");
                          setActiveItem("tickets-cxo");
                          setShowNotifications(false);
                        }}
                        className="cursor-pointer bg-amber-500/5 border-l-2 border-amber-500 m-1 rounded"
                      >
                        <div className="w-full py-1">
                          <div className="flex items-center gap-2 mb-1">
                            <TrendingUp className="w-4 h-4 text-amber-400" />
                            <span className="text-xs font-medium text-amber-400">CMO IA</span>
                            <span className={`text-xs px-1.5 py-0.5 rounded ${
                              alert.priority === 'high' ? 'bg-red-500/20 text-red-400' : 'bg-amber-500/20 text-amber-400'
                            }`}>
                              {alert.priority === 'high' ? 'Urgent' : 'Important'}
                            </span>
                          </div>
                          <p className="text-sm text-white font-medium">{alert.title}</p>
                          <p className="text-xs text-zinc-400 mt-0.5">{alert.reason}</p>
                        </div>
                      </DropdownMenuItem>
                    ))}

                    {/* Alertes COO */}
                    {cxoNotifications.coo?.alerts?.map((alert, i) => (
                      <DropdownMenuItem 
                        key={`coo-${i}`}
                        onClick={() => {
                          setActiveHub("operation");
                          setActiveItem("tickets-cxo");
                          setShowNotifications(false);
                        }}
                        className="cursor-pointer bg-emerald-500/5 border-l-2 border-emerald-500 m-1 rounded"
                      >
                        <div className="w-full py-1">
                          <div className="flex items-center gap-2 mb-1">
                            <Cog className="w-4 h-4 text-emerald-400" />
                            <span className="text-xs font-medium text-emerald-400">COO IA</span>
                          </div>
                          <p className="text-sm text-white font-medium">{alert.title}</p>
                          <p className="text-xs text-zinc-400 mt-0.5">{alert.reason}</p>
                        </div>
                      </DropdownMenuItem>
                    ))}

                    {/* Alertes CTO */}
                    {cxoNotifications.cto?.alerts?.map((alert, i) => (
                      <DropdownMenuItem 
                        key={`cto-${i}`}
                        onClick={() => {
                          setActiveHub("operation");
                          setActiveItem("tickets-cxo");
                          setShowNotifications(false);
                        }}
                        className="cursor-pointer bg-blue-500/5 border-l-2 border-blue-500 m-1 rounded"
                      >
                        <div className="w-full py-1">
                          <div className="flex items-center gap-2 mb-1">
                            <Server className="w-4 h-4 text-blue-400" />
                            <span className="text-xs font-medium text-blue-400">CTO IA</span>
                          </div>
                          <p className="text-sm text-white font-medium">{alert.title}</p>
                          <p className="text-xs text-zinc-400 mt-0.5">{alert.reason}</p>
                        </div>
                      </DropdownMenuItem>
                    ))}

                    {/* Bureau AMO — mails prêts ou à trancher (W-1) */}
                    {emailNotifications.count > 0 && (
                      <DropdownMenuItem
                        data-testid="cloche-bureau-amo"
                        onClick={() => {
                          setShowHomePage(false);
                          setActiveDirectionAgent(null);
                          setActiveGlobalPage(null);
                          setActiveHub("communication");
                          setActiveItem("ag04-amo");
                          setCleBureau((n) => n + 1);
                          setShowNotifications(false);
                        }}
                        className="cursor-pointer m-1 rounded"
                        style={{ background: "var(--oh-accent-bg)", borderLeft: "2px solid var(--oh-accent)" }}
                      >
                        <div className="w-full py-1">
                          <div className="flex items-center gap-2">
                            <Mail className="w-4 h-4" aria-hidden="true" style={{ color: "var(--oh-accent-text)" }} />
                            <span className="text-sm font-medium" style={{ color: "var(--oh-accent-text)" }}>
                              {libelleCloche(emailNotifications.count)}
                            </span>
                          </div>
                        </div>
                      </DropdownMenuItem>
                    )}

                    {/* Alertes WhatsApp Bailey */}
                    {whatsappNotifications.count > 0 && (
                      <>
                        <div className="px-3 py-1.5 border-t border-white/5 mt-1">
                          <p className="text-xs text-zinc-500 flex items-center gap-1.5">
                            <MessageSquare className="w-3 h-3 text-green-400" />
                            Bailey WhatsApp — {whatsappNotifications.count} action(s) en attente
                          </p>
                        </div>
                        {whatsappNotifications.alerts?.map((alert, i) => (
                          <DropdownMenuItem 
                            key={`wa-${i}`}
                            onClick={() => {
                              setActiveHub("communication");
                              setActiveItem("bailey");
                              setShowNotifications(false);
                            }}
                            className="cursor-pointer bg-green-500/5 border-l-2 border-green-500 m-1 rounded"
                          >
                            <div className="w-full py-1">
                              <div className="flex items-center gap-2 mb-1">
                                <MessageSquare className="w-4 h-4 text-green-400" />
                                <span className="text-xs font-medium text-green-400">WhatsApp</span>
                                {alert.group && (
                                  <span className="text-xs px-1.5 py-0.5 rounded bg-green-500/20 text-green-400 truncate max-w-[100px]">
                                    {alert.group}
                                  </span>
                                )}
                              </div>
                              <p className="text-sm text-white font-medium truncate">{alert.title}</p>
                              <p className="text-xs text-zinc-400 mt-0.5 truncate">{alert.message}</p>
                            </div>
                          </DropdownMenuItem>
                        ))}
                      </>
                    )}

                    {/* Tickets OH — mes tickets ouverts */}
                    {ticketNotifications.mine.length > 0 && (
                      <>
                        <div className="px-3 py-1.5 border-t border-white/5 mt-1">
                          <p className="text-xs text-zinc-500 flex items-center gap-1.5">
                            <Ticket className="w-3 h-3 text-blue-400" />
                            Mes tickets — {ticketNotifications.mine.length} ouvert(s)
                          </p>
                        </div>
                        {ticketNotifications.mine.slice(0, 5).map(t => (
                          <DropdownMenuItem
                            key={`tk-mine-${t.id}`}
                            onClick={() => {
                              setShowGovernance(true);
                              setInitialGovernanceWidget("tickets");
                              setShowHomePage(false);
                              setActiveDirectionAgent(null);
                              setActiveGlobalPage(null);
                              setActiveHub(null);
                              setActiveItem(null);
                              setShowNotifications(false);
                            }}
                            className="cursor-pointer bg-blue-500/5 border-l-2 border-blue-500 m-1 rounded"
                          >
                            <div className="w-full py-1">
                              <div className="flex items-center gap-2 mb-1">
                                <Ticket className="w-4 h-4 text-blue-400" />
                                <span className="text-xs font-medium text-blue-400">{t.reference}</span>
                                <span className={`text-xs px-1.5 py-0.5 rounded ${
                                  t.priority === 'critical' ? 'bg-red-500/20 text-red-400'
                                  : t.priority === 'high' ? 'bg-orange-500/20 text-orange-400'
                                  : 'bg-zinc-500/20 text-zinc-400'
                                }`}>
                                  {t.priority}
                                </span>
                                <span className="text-xs text-zinc-500 capitalize">{t.status}</span>
                              </div>
                              <p className="text-sm text-white font-medium truncate">{t.title}</p>
                            </div>
                          </DropdownMenuItem>
                        ))}
                      </>
                    )}

                    {/* Tickets OH — urgents (super admin) */}
                    {ticketNotifications.urgent.length > 0 && (
                      <>
                        <div className="px-3 py-1.5 border-t border-white/5 mt-1">
                          <p className="text-xs text-zinc-500 flex items-center gap-1.5">
                            <AlertTriangle className="w-3 h-3 text-red-400" />
                            Tickets urgents — {ticketNotifications.urgent.length} (critical/high)
                          </p>
                        </div>
                        {ticketNotifications.urgent.slice(0, 5).map(t => (
                          <DropdownMenuItem
                            key={`tk-urg-${t.id}`}
                            onClick={() => {
                              setShowGovernance(true);
                              setInitialGovernanceWidget("tickets");
                              setShowHomePage(false);
                              setActiveDirectionAgent(null);
                              setActiveGlobalPage(null);
                              setActiveHub(null);
                              setActiveItem(null);
                              setShowNotifications(false);
                            }}
                            className="cursor-pointer bg-red-500/5 border-l-2 border-red-500 m-1 rounded"
                          >
                            <div className="w-full py-1">
                              <div className="flex items-center gap-2 mb-1">
                                <AlertTriangle className="w-4 h-4 text-red-400" />
                                <span className="text-xs font-medium text-red-400">{t.reference}</span>
                                <span className={`text-xs px-1.5 py-0.5 rounded ${
                                  t.priority === 'critical' ? 'bg-red-500/20 text-red-400' : 'bg-orange-500/20 text-orange-400'
                                }`}>
                                  {t.priority}
                                </span>
                                <span className="text-xs text-zinc-500 capitalize">{t.status}</span>
                                {t.assigned_to && (
                                  <span className="text-xs text-zinc-500 truncate max-w-[120px]">→ {t.assigned_to}</span>
                                )}
                              </div>
                              <p className="text-sm text-white font-medium truncate">{t.title}</p>
                            </div>
                          </DropdownMenuItem>
                        ))}
                      </>
                    )}

                    {/* Aucune notification */}
                    {!(cxoNotifications.cmo?.needsAttention ||
                       cxoNotifications.coo?.needsAttention ||
                       cxoNotifications.cto?.needsAttention ||
                       emailNotifications.count > 0 ||
                       whatsappNotifications.count > 0 ||
                       ticketNotifications.mine.length > 0 ||
                       ticketNotifications.urgent.length > 0) && (
                      <div className="px-4 py-6 text-center">
                        <div className="w-12 h-12 rounded-full bg-emerald-500/10 flex items-center justify-center mx-auto mb-3">
                          <Bell className="w-6 h-6 text-emerald-400" />
                        </div>
                        <p className="text-zinc-400 text-sm font-medium">Tout est sous controle</p>
                        <p className="text-zinc-500 text-xs mt-1">
                          Aucune décision ne requiert votre attention
                        </p>
                      </div>
                    )}
                    
                    {/* Lien vers Tickets CxO */}
                    <div className="px-3 py-2 border-t border-white/5">
                      <button
                        onClick={() => {
                          setShowHomePage(false);
                          setActiveGlobalPage(null);
                          setActiveDirectionAgent(null);
                          setActiveHub("operation");
                          setActiveItem("tickets-cxo");
                          setExpandedHubs(prev => prev.includes('operation') ? prev : [...prev, 'operation']);
                          setShowNotifications(false);
                        }}
                        className="w-full text-center text-sm text-blue-400 hover:text-blue-300 py-1"
                        data-testid="header-view-all-notifications"
                      >
                        Voir tous les tickets CxO →
                      </button>
                    </div>
                  </DropdownMenuContent>
                </DropdownMenu>
                </>
                )}

                {/* 2.5 Gouvernance CTO - Accès Super Admin uniquement ou si hub gouvernance activé */}
                {(user?.is_super_admin || isSuperAdmin()) && (
                <button 
                  onClick={() => { 
                    setShowGovernance(true);
                    setShowHomePage(false);
                    setActiveDirectionAgent(null);
                    setActiveGlobalPage(null);
                    setActiveHub(null);
                    setActiveItem(null);
                  }}
                  className={`p-2 rounded-lg transition-colors ${
                    showGovernance 
                      ? 'bg-amber-500/20 text-amber-400' 
                      : 'hover:bg-zinc-800/50 text-zinc-400 hover:text-amber-400'
                  }`}
                  data-testid="header-governance"
                  title="Gouvernance CTO"
                >
                  <Settings2 className="w-5 h-5" />
                </button>
                )}

                {/* 3. Utilisateurs & Rôles - MIGRÉ vers Gouvernance - Super Admin ou hub gouvernance activé */}
                {(user?.is_super_admin || isSuperAdmin()) && (
                <button 
                  onClick={() => { 
                    // Ouvre l'espace Gouvernance directement sur le widget Sécurité
                    setInitialGovernanceWidget("security");
                    setShowGovernance(true);
                    setShowHomePage(false);
                    setActiveDirectionAgent(null);
                    setActiveGlobalPage(null);
                    setActiveHub(null);
                    setActiveItem(null);
                  }}
                  className={`hidden md:flex items-center gap-2 p-2 rounded-lg transition-colors ${
                    showGovernance 
                      ? 'bg-red-500/20 text-red-400' 
                      : 'hover:bg-zinc-800/50 text-zinc-400 hover:text-white'
                  }`}
                  data-testid="header-users-roles"
                  title="Utilisateurs & Rôles (Gouvernance)"
                >
                  <Users className="w-5 h-5" />
                </button>
                )}

                {/* 4. Paramètres - Redirige vers Identité Entreprise (Admin/Super Admin only) */}
                {(user?.role === 'admin' || user?.role === 'super_admin' || user?.is_super_admin) && (
                <button 
                  onClick={() => { 
                    setActiveDirectionAgent(null);
                    setShowHomePage(false);
                    setActiveGlobalPage(null);
                    setActiveHub("management");
                    setActiveItem("identite-entreprise");
                    if (!expandedHubs.includes("management")) {
                      setExpandedHubs(prev => [...prev, "management"]);
                    }
                  }}
                  className={`hidden md:flex items-center gap-2 p-2 rounded-lg transition-colors ${
                    activeHub === 'management' && activeItem === 'identite-entreprise'
                      ? 'bg-zinc-800 text-white' 
                      : 'hover:bg-zinc-800/50 text-zinc-400 hover:text-white'
                  }`}
                  data-testid="header-settings"
                  title="Paramètres Entreprise"
                >
                  <Settings className="w-5 h-5" />
                </button>
                )}

                {/* Theme toggle */}
                {<button
                  onClick={toggleTheme}
                  className="p-2 rounded-lg hover:bg-zinc-800/50 text-zinc-400 hover:text-white transition-colors"
                  data-testid="theme-toggle"
                  title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
                >
                  {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                </button>}

                {/* 5. User dropdown */}
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button className="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-zinc-800/50 transition-colors">
                      {(user.avatar_url || user.picture) ? (
                        <img src={user.avatar_url || user.picture} alt="" className="w-8 h-8 rounded-full ring-2 ring-white/10 object-cover" />
                      ) : (
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center ring-2 ring-white/10">
                          <span className="text-white text-sm font-medium">
                            {user.name?.charAt(0) || user.email?.charAt(0) || '?'}
                          </span>
                        </div>
                      )}
                      <div className="hidden sm:block text-left">
                        <p className="text-sm font-medium text-white">{user.name || 'Utilisateur'}</p>
                        <p className="text-xs text-zinc-500">{user.email}</p>
                      </div>
                      <ChevronDown className="w-4 h-4 text-zinc-500" />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-56 bg-zinc-900 border-white/10">
                    <div className="px-3 py-2 border-b border-white/5">
                      <p className="text-sm font-medium text-white">{user.name || 'Utilisateur'}</p>
                      <p className="text-xs text-zinc-500">{user.email}</p>
                    </div>
                    <DropdownMenuItem 
                      onClick={() => {
                        setActiveDirectionAgent(null);
                        setShowHomePage(false);
                        setActiveGlobalPage('profil');
                      }}
                      className="cursor-pointer hover:bg-zinc-800"
                      data-testid="header-mon-profil"
                    >
                      <User className="w-4 h-4 mr-2 text-blue-400" />
                      Mon Profil
                    </DropdownMenuItem>
                    {/* User Switcher - Admin & Super Admin */}
                    <UserSwitcher
                      currentEmail={user?.email}
                      isAdmin={isAdmin}
                      isSuperAdmin={isSuperAdmin()}
                    />
                    <DropdownMenuItem 
                      onClick={logout}
                      className="text-red-400 hover:text-red-300 hover:bg-red-500/10 cursor-pointer"
                    >
                      <LogOut className="w-4 h-4 mr-2" />
                      Déconnexion
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            )}
          </div>
        </div>

        {/* Impersonation Banner */}
        {isImpersonating && (
          <div className="bg-amber-500/10 border-b border-amber-500/20 px-4 py-2 flex items-center justify-between" data-testid="impersonation-banner">
            <div className="flex items-center gap-2 text-amber-400 text-sm">
              <Users className="w-4 h-4" />
              <span>Mode impersonation : vous naviguez en tant que <strong>{user?.name || user?.email}</strong></span>
            </div>
            <button
              onClick={() => {
                const origToken = localStorage.getItem("original_admin_token");
                if (origToken) {
                  localStorage.setItem("session_token", origToken);
                  localStorage.removeItem("original_admin_token");
                  window.location.reload();
                }
              }}
              className="px-3 py-1 text-xs font-semibold bg-amber-500/20 text-amber-300 rounded hover:bg-amber-500/30 transition"
              data-testid="impersonation-back-btn"
            >
              Revenir Admin
            </button>
          </div>
        )}

        {/* Content */}
        <div className="p-3 sm:p-4 lg:p-6 pb-20 lg:pb-6">
          {/* 🔴 N°1001-C2 — une exception de rendu reste CONFINÉE au contenu : menu et
              navigation restent utilisables (plus de page blanche totale). */}
          <ErrorBoundaryContenu key={`${showHomePage ? "accueil" : ""}:${activeItem || ""}`}
                                ecran={showHomePage ? "accueil" : activeItem}
                                onRetour={() => { setActiveItem(null); setShowHomePage(true); }}>
            {renderContent()}
          </ErrorBoundaryContenu>
        </div>
        
        {/* Mobile Bottom Navigation */}
        {<MobileBottomNav 
          activeItem={
            showHomePage ? "home" :
            (activeHub === "metier" && activeItem === "dossiers") ? "dossiers" :
            (activeHub === "metier" && activeItem === "clients") ? "clients" :
            activeItem === "notifications" ? "notifications" :
            activeItem === "profile" ? "profile" :
            null
          }
          onNavigate={(item) => {
            if (item.id === "home") {
              navigateToHome();
            } else if (item.id === "profile") {
              setShowHomePage(false);
              setActiveHub("management");
              setActiveItem("profil");
              if (!expandedHubs.includes("management")) {
                setExpandedHubs(prev => [...prev, "management"]);
              }
            } else if (item.id === "notifications") {
              setShowHomePage(false);
              setActiveHub("management");
              setActiveItem("notifications");
            } else if (item.hub && item.item) {
              selectItem(item.hub, item.item);
            }
          }}
        />}
      </main>
    </div>
  );
}

// Composant Coming Soon
function ComingSoon({ title }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-zinc-800 to-zinc-900 flex items-center justify-center mb-6">
        <Sparkles className="w-10 h-10 text-zinc-600" />
      </div>
      <h2 className="text-2xl font-bold text-white mb-2">{title}</h2>
      <p className="text-zinc-400 mb-6 max-w-md">
        Ce module est en cours de développement et sera disponible prochainement.
      </p>
      <div className="flex items-center gap-2 text-sm text-zinc-500">
        <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse"></div>
        Coming Soon
      </div>
    </div>
  );
}

// =============================================================================
// HubsNavigation - Navigation filtrée selon les permissions
// =============================================================================
function HubsNavigation({ 
  hubs, 
  activeHub, 
  activeItem, 
  activeDirectionAgent,
  expandedHubs, 
  expandedSubMenus, 
  sidebarOpen,
  openTicketsCount,
  currentEntreprise,
  currentUser,
  toggleHub, 
  selectItem,
  setExpandedSubMenus 
}) {
  const { isHubEnabled, isFeatureEnabled, isFeatureGranted, isFeatureExact, peutOuvrirBureau, peutOuvrirAcces, loading } = usePermissions();

  // T-461 : si la page en cours est un sous-élément d'un sous-menu, ce sous-menu est ouvert (les autres restent fermés).
  useEffect(() => {
    const hub = hubs.find((h) => h.id === activeHub);
    const parent = hub?.items?.find((it) => Array.isArray(it.subItems) && it.subItems.some((si) => si.id === activeItem));
    if (parent) setExpandedSubMenus((prev) => (prev.includes(parent.id) ? prev : [...prev, parent.id]));
  }, [hubs, activeHub, activeItem, setExpandedSubMenus]);

  // Filtrer les hubs selon les permissions (Feature Flags) et le role
  const visibleHubs = hubs.filter(hub => {
    // RÉGIE : vue cloisonnée → SEUL le Hub Commercial (qui porte le menu Prospects).
    // Le verrou réel est backend (allowlist + filtre created_by).
    if (currentUser?.role === "regie") {
      return hub.id === "commercial";
    }
    // Pendant le chargement, tout est visible
    if (loading) return true;
    // User Externe / Installateur — MINI-APP épurée (CC-DEV1) : un seul hub
    // "commercial" (vue d'ensemble InstallateurOverview + ses dossiers + création).
    // OH-0019 : "installateur" DOIT être miroir de "external" ici — sinon il tombait
    // sur le défaut allow-all (isHubEnabled) et voyait TOUS les hubs (Catalogue/Config).
    // On garde la restriction preprod la PLUS FORTE (commercial SEUL), pas
    // commercial+opération+conformité de la version prod.
    if (currentUser?.role === "external" || currentUser?.role === "installateur") {
      return hub.id === "commercial";
    }
    // Vérifier si le hub est activé pour le tenant
    return isHubEnabled(hub.id);
  });
  
  return (
    <>
      {sidebarOpen && (
        <p className="px-3 mb-2 text-xs font-semibold text-zinc-500 uppercase tracking-wider">
          Hubs
        </p>
      )}
      {visibleHubs.map(hub => (
        <div key={hub.id} className="mb-2">
          {/* Hub Header */}
          <button
            onClick={() => toggleHub(hub.id)}
            data-testid={`nav-hub-${hub.id}`}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${activeHub === hub.id && !activeDirectionAgent ? hub.bgColor : 'hover:bg-zinc-800/50'}`}
          >
            <hub.icon className={`w-5 h-5 ${hub.color} flex-shrink-0`} />
            {sidebarOpen && (
              <>
                <span className="flex-1 text-left text-sm font-medium text-white">{libelleHub(hub)}</span>
                {expandedHubs.includes(hub.id) ? (
                  <ChevronDown className="w-4 h-4 text-zinc-500" />
                ) : (
                  <ChevronRight className="w-4 h-4 text-zinc-500" />
                )}
              </>
            )}
          </button>

          {/* Hub Items */}
          {sidebarOpen && expandedHubs.includes(hub.id) && (
            <div className="ml-4 mt-1 space-y-1">
              {hub.items.filter(item => {
                // CC-DEV1 : l'installateur a une entrée "Nouveau Dossier" visible
                // (normalement hidden) — point d'entrée de création de sa mini-app.
                if (item.hidden && !(currentUser?.role === "external" && item.id === "nouveau-dossier")) return false;
                // RÉGIE : STRICTEMENT le menu Prospects (court-circuite tenant/role/
                // feature-flag → toujours visible pour elle, et rien d'autre).
                if (currentUser?.role === "regie") {
                  // T-203 : + « À faire », sous la capacité `commercial.crm_actions` (lecture stricte) — la régie suit SES actions sur SES prospects.
                  return hub.id === "commercial" && (item.id === "prospects-staging" || (item.id === "a-faire" && isFeatureGranted("commercial.crm_actions")));
                }
                // Super-admin bypasse TOUS les gates tenant (comme il bypasse
                // déjà rôle ci-dessous et feature-flag) → voit tous les menus,
                // tous tenants (Aides/CERFA/MaPrimeAdapt' visibles depuis TEF).
                if (item.tenants && !item.tenants.includes(currentEntreprise?.slug) && !currentUser?.is_super_admin) return false;
                // 🔴 CAPACITÉ DÉCLARÉE — évaluée comme le gate tenant, super-admin inclus.
                // ⚠️ Un nom absent du registre MASQUE l'entrée : une capacité mal
                // orthographiée ⛔ ne doit pas ouvrir la porte en silence.
                if (item.capability && !currentUser?.is_super_admin
                    && !aLaCapaciteDuMenu(item)) return false;
                // 🔴 ETI-113-B — INTÉGRATION ACTIVE du tenant : ⛔ aucun contournement super-admin
                // (propriété du TENANT, pas du lecteur). Absente/inactive ⇒ entrée masquée.
                if (item.integration === "pennylane" && !hasIntegrationPennylane()) return false;
                if (item.roles && !item.roles.includes(currentUser?.role) && !currentUser?.is_super_admin) return false;
                // Feature flag : source de vérité gouvernance.
                // Si un item est tagué avec `feature`, on respecte strictement le flag.
                // Pas de tag = item toujours visible (backward compat).
                if (item.feature && !loading && !isFeatureEnabled(item.feature)) return false;
                // Clé de visibilité STRICTE (absente ou contexte non chargé = masqué).
                if (item.featureStrict && !isFeatureGranted(item.featureStrict)) return false;
                // T-351b : l'entrée « Bureau AMO » n'apparaît que si le serveur dit que ce compte peut l'ouvrir (rôle admin ET module bureau_amo).
                if (item.acces === "bureau_amo" && !peutOuvrirBureau()) return false;
                if (item.acces && item.acces !== "bureau_amo" && !peutOuvrirAcces(item.acces)) return false;      // T-406 : bureau_chloe, bureau_joey
                // Clé EXACTE sans contournement super-admin (choix métier du tenant : menu « Clients »).
                if (item.featureExact && !isFeatureExact(item.featureExact)) return false;
                // Filtrage pour User Externe / Installateur par hub (OH-0019 :
                // "installateur" mirrored sur "external" — sinon défaut allow-all →
                // items admin visibles). Mini-app épurée : vue d'ensemble + création + ses dossiers.
                if (currentUser?.role === "external" || currentUser?.role === "installateur") {
                  const externalAllowedByHub = {
                    commercial: ["dashboard", "nouveau-dossier", "dossiers"],
                  };
                  const allowed = externalAllowedByHub[hub.id] || [];
                  return allowed.includes(item.id);
                }
                return true;
              }).map((item, idx, liste) => (
                <div key={item.id}>
                  {/* T-486 : sous-titre de GROUPE (« Mails », « Messagerie & téléphone ») au premier élément visible du groupe */}
                  {item.groupe && (idx === 0 || liste[idx - 1].groupe !== item.groupe) && (
                    <p className="px-3 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wider" style={{ color: "var(--oh-text-muted)" }} data-testid={`nav-groupe-${hub.id}-${item.groupe}`}>{item.groupe}</p>
                  )}
                  {/* Item avec sous-menu */}
                  {item.subItems ? (
                    <div>
                      <div className="flex items-center">
                        <button
                          onClick={() => selectItem(hub.id, item.id)}
                          data-testid={`nav-item-${hub.id}-${item.id}`}
                          className={`flex-1 flex items-center gap-3 px-3 py-2 rounded-l-lg text-sm transition-colors ${
                            activeHub === hub.id && activeItem === item.id && !activeDirectionAgent
                              ? 'bg-[var(--oh-accent-bg)] text-[var(--oh-accent-text)]'
                              : 'text-zinc-400 hover:text-white hover:bg-zinc-800/50'
                          }`}
                        >
                          <item.icon className="w-4 h-4" />
                          <span>{item.id === 'aides' ? aidesLabel('aides_menu', currentShowsMpr()) : item.label}</span>
                        </button>
                        <button
                          onClick={() => {
                            setExpandedSubMenus(prev => 
                              prev.includes(item.id) 
                                ? prev.filter(id => id !== item.id)
                                : [...prev, item.id]
                            );
                          }}
                          className="px-2 py-2 rounded-r-lg text-zinc-400 hover:text-white hover:bg-zinc-800/50"
                        >
                          {expandedSubMenus.includes(item.id) ? (
                            <ChevronDown className="w-3 h-3" />
                          ) : (
                            <ChevronRight className="w-3 h-3" />
                          )}
                        </button>
                      </div>
                      {expandedSubMenus.includes(item.id) && (
                        <div className="ml-4 mt-1 space-y-1">
                          {item.subItems.map(subItem => (
                            <button
                              key={subItem.id}
                              onClick={() => selectItem(hub.id, subItem.id)}
                              data-testid={`nav-subitem-${hub.id}-${subItem.id}`}
                              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                                activeHub === hub.id && activeItem === subItem.id && !activeDirectionAgent
                                  ? 'bg-[var(--oh-accent-bg)] text-[var(--oh-accent-text)] border-l-2 border-[var(--oh-accent-text)]'
                                  : 'text-zinc-500 hover:text-white hover:bg-zinc-800/50'
                              }`}
                            >
                              <subItem.icon className="w-4 h-4" />
                              <span>{subItem.label}</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={() => !item.comingSoon && selectItem(hub.id, item.id)}
                      disabled={item.comingSoon}
                      data-testid={`nav-item-${hub.id}-${item.id}`}
                      className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                        item.comingSoon
                          ? 'opacity-50 cursor-not-allowed'
                          : activeHub === hub.id && activeItem === item.id && !activeDirectionAgent
                            ? 'bg-[var(--oh-accent-bg)] text-[var(--oh-accent-text)]'
                            : 'text-zinc-400 hover:text-white hover:bg-zinc-800/50'
                      }`}
                    >
                      <item.icon className="w-4 h-4" />
                      <span>{item.id === 'aides' ? aidesLabel('aides_menu', currentShowsMpr()) : item.label}</span>
                      {item.id === 'tickets-cxo' && openTicketsCount > 0 && (
                        <span className="ml-auto min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-medium rounded-full bg-red-500/20 text-red-400 border border-red-500/30">
                          {openTicketsCount}
                        </span>
                      )}
                      {item.comingSoon && (
                        <span className="ml-auto text-[9px] px-1.5 py-0.5 rounded bg-amber-500/20 text-amber-400 font-medium">
                          V2
                        </span>
                      )}
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </>
  );
}

// =============================================================================
// EXPORT - Wrapper avec PermissionProvider
// =============================================================================

// Composant principal exporté - Wrapper avec PermissionProvider
export default function OmniHub() {
  const { user, isAuthenticated, loading: authLoading } = useAuth();
  const [currentTenantForPermissions, setCurrentTenantForPermissions] = useState(null);
  const [tenantLoading, setTenantLoading] = useState(true);
  const [sansBulles, setSansBulles] = useState(false);   // T-404c : sur le Bureau, la bulle d'aide Support n'est pas affichée
  
  // Charger le tenant au niveau du wrapper (avant PermissionProvider)
  useEffect(() => {
    if (!isAuthenticated || !user?.email) {
      setTenantLoading(false);
      return;
    }
    
    const loadTenant = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL;
        const token = localStorage.getItem('session_token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        
        const res = await fetch(
          `${API}/api/platform/user/tenants?user_email=${encodeURIComponent(user.email)}`,
          { credentials: 'include', headers }
        );
        
        if (res.ok) {
          const data = await res.json();
          const list = data.tenants || [];
          if (list.length > 0) {
            // Priorité : 
            // 1. current_tenant_slug du backend (SOURCE UNIQUE)
            // 2. localStorage (cache)
            // 3. Tenant par défaut
            // 4. Premier de la liste
            let selectedTenant = null;
            
            // PRIORITÉ 1: Backend current_tenant
            const backendCurrentSlug = data.current_tenant_slug;
            if (backendCurrentSlug) {
              selectedTenant = list.find(t => t.slug === backendCurrentSlug);
            }
            
            // PRIORITÉ 2: localStorage
            if (!selectedTenant) {
              const storedSlug = localStorage.getItem('current_tenant_slug');
              if (storedSlug) {
                selectedTenant = list.find(t => t.slug === storedSlug);
              }
            }
            
            // PRIORITÉ 3-4: is_default ou premier
            if (!selectedTenant) {
              selectedTenant = list.find(t => t.is_default) || list[0];
            }
            
            // Synchroniser localStorage
            if (selectedTenant) {
              localStorage.setItem('current_tenant_slug', selectedTenant.slug);
              localStorage.setItem('current_business_model', selectedTenant.business_model || '');
              appliquerAccentDuTenant(selectedTenant);
              localStorage.setItem('current_segments', JSON.stringify(selectedTenant.segments || []));
              if (selectedTenant.dossier_creation_profile) {
                localStorage.setItem('current_dossier_creation_profile', selectedTenant.dossier_creation_profile);
              } else {
                localStorage.removeItem('current_dossier_creation_profile');
              }
              if (selectedTenant.dossier_activite) {
                localStorage.setItem('current_dossier_activite', selectedTenant.dossier_activite);
              } else {
                localStorage.removeItem('current_dossier_activite');
              }
              // 🔴 CAPABILITY AMO — DÉCLARATION POSITIVE servie par le serveur.
              // ⛔ Remplace la règle EN CREUX `!isOmv`, qui donnait l'onglet
              // « Missions AMO » à tout tenant n'étant pas OMV — donc à Mario.
              // ⛔ Aucun repli : absente ⇒ la clé est RETIRÉE, jamais héritée.
              if (selectedTenant.amo_missions) {
                localStorage.setItem('current_amo_missions', '1');
              } else {
                localStorage.removeItem('current_amo_missions');
              }
              // 🔴 CAPABILITÉ VISITE TERRAIN — même principe : DÉCLARÉE, jamais devinée.
              if (selectedTenant.visites_terrain) {
                localStorage.setItem('current_visites_terrain', '1');
              } else {
                localStorage.removeItem('current_visites_terrain');
              }
              // 🔴 CAPACITÉ DEVIS — DÉCLARÉE, jamais dérivée du business_model.
              if (selectedTenant.devis_catalogue) {
                localStorage.setItem('current_devis_catalogue', '1');
              } else {
                localStorage.removeItem('current_devis_catalogue');
              }
              // 🔴 N°690-2 — SOUS-TRAITANCE : le tenant fait-il POSER ?
              // ⛔ Non déclarée ⇒ clé RETIRÉE, jamais héritée (défaut sûr).
              if (selectedTenant.devis_installateur_requis) {
                localStorage.setItem('current_devis_installateur', '1');
              } else {
                localStorage.removeItem('current_devis_installateur');
              }
              // 🔴 CLI-17 — défaut « installateur interne », mis en cache aux
              //    TROIS points où l'est la capacité voisine. ⚠️ En oublier un
              //    laisserait un chemin où la capacité ⛔ n'arrive JAMAIS.
              if (selectedTenant.devis_installateur_interne_par_defaut) {
                localStorage.setItem('current_devis_installateur_interne_par_defaut', '1');
              } else {
                localStorage.removeItem('current_devis_installateur_interne_par_defaut');
              }
              // 🔴 L2 (N°876) — MODÈLE SITE ADOPTÉ (client → site → dossier) ?
              // ⛔ Non déclaré ⇒ clé RETIRÉE : TEF/OMV/Climat ⛔ ne changent pas.
              if (selectedTenant.dossier_site_requis) {
                localStorage.setItem('current_dossier_site_requis', '1');
              } else {
                localStorage.removeItem('current_dossier_site_requis');
              }
              // Chantier : profil de relevé DÉCLARÉ par le tenant (code) ; absent ⇒ retiré.
              if (selectedTenant.profil_chantier) {
                localStorage.setItem('current_profil_chantier', selectedTenant.profil_chantier);
              } else {
                localStorage.removeItem('current_profil_chantier');
              }
              // Pennylane : capacité DÉCLARÉE du tenant (feature flag integration.pennylane)
              if (selectedTenant.integration_pennylane) {
                localStorage.setItem('current_integration_pennylane', '1');
              } else {
                localStorage.removeItem('current_integration_pennylane');
              }
              // 🔴 CAPACITÉ AIDES/AMO — compose la fiche dossier. DÉCLARÉE.
              if (selectedTenant.dossier_amo) {
                localStorage.setItem('current_dossier_amo', '1');
              } else {
                localStorage.removeItem('current_dossier_amo');
              }
              localStorage.setItem('current_regime_aides', JSON.stringify(selectedTenant.regime_aides || []));
            }
            
            setCurrentTenantForPermissions(selectedTenant);
          }
        }
      } catch (err) {
        console.error('Erreur chargement tenant:', err);
      } finally {
        setTenantLoading(false);
      }
    };
    
    loadTenant();
  }, [isAuthenticated, user?.email]);
  
  // Afficher le loader pendant le chargement auth ou tenant
  if (authLoading || (isAuthenticated && tenantLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--oh-bg)' }}>
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-blue-500 animate-spin mx-auto mb-4" />
          <p style={{ color: 'var(--oh-text-muted)' }}>Chargement...</p>
        </div>
      </div>
    );
  }
  
  // Si authentifié, wrapper avec PermissionProvider (tenant déjà chargé)
  if (isAuthenticated && user) {
    return (
      <PermissionProvider user={user} currentTenant={currentTenantForPermissions}>
        <OmniHubInner 
          permissionTenant={currentTenantForPermissions} 
          setPermissionTenant={setCurrentTenantForPermissions} 
          onBureauSeul={setSansBulles}
        />
        {!sansBulles && <SupportChatWidget />}
      </PermissionProvider>
    );
  }
  
  // Sinon, afficher directement (page de login) - avec PermissionProvider vide
  return (
    <PermissionProvider user={null} currentTenant={null}>
      <OmniHubInner permissionTenant={null} setPermissionTenant={() => {}} />
    </PermissionProvider>
  );
}

export { OmniHub };
// Force rebuild 1767531239

